<template>
  <div
    class="pt-0"
    style="padding-left: 2%; padding-right: 2%; background-color: #F8F9FA;"
  >
    <v-row class="mb-2">
      <v-col cols="12" lg="7" md="7" sm="12">
        <img
          width="10"
          height="14"
          src="@/assets/icons/back.png"
          class="mt-5 ml-0"
          style="cursor: pointer;"
          @click="goBack()"
        />
        <span class="header-title ml-0">
          ข้อมูลลงทะเบียนธุรกิจ
        </span>
        <v-chip
            v-if="getStatus !== ''"
            :color="getStatus == 'approved' || getStatus == 'acknowledge' ? '#ECF8EA' : getStatus == 'reject' || getStatus == 'denied' ? '#FBE5E4' : getStatus == 'pending' ? '#FEF5E9' : getStatus == 'cancel' ? '#F5F5F5':'#ECF9FF'"
            :text-color="getStatus == 'approved' || getStatus == 'acknowledge' ? '#58A144' : getStatus == 'reject' || getStatus == 'denied' ? '#D1392B' : getStatus == 'pending' ? '#E9A016' : getStatus == 'cancel' ? '#757575':'#ECF9FF'"
          >
            <span>{{ getStatus == 'approved' || getStatus == 'acknowledge' ? 'อนุมัติ' : getStatus == 'reject' || getStatus == 'denied' ? 'ไม่อนุมัติ' : getStatus == 'pending' ? 'รออนุมัติ' : getStatus == 'cancel' ? 'ยกเลิก':'-'}}</span>
          </v-chip>
      </v-col>
      <!-- <v-col
        cols="12" lg="5" md="5" sm="12"
        class="pt-0 pb-0 d-flex align-center justify-end mt-4 action-top-btn"
      >
        <p
          v-show="itemVersion.length > 1"
          class="txt-font px-3 pt-2"
          style="margin-top: 0%;"
        >
          เวอร์ชั่น:
        </p>
        <v-select
          v-show="itemVersion.length > 1"
          v-model="versionDate"
          :items="itemVersion"
          item-text="detail"
          item-value="_id"
          class="mr-3 mt-3 elevation-0"
          background-color="#ffffff"
          @change="chageVersion(versionDate)"
          dense
          outlined
        >
        </v-select>
        <v-btn
          class="button-color-outline ma-0"
          outlined
          @click="copyData()"
          >คัดลอก</v-btn
        >
        <v-btn
          v-if="editMode === true"
          class="button-color-outline ma-2 mr-3"
          outlined
          @click="editMode = false"
          >ยกเลิกการแก้ไข</v-btn
        >
        <v-btn
          v-else
          class="button-color-outline ma-2 mr-3"
          outlined
          dark
          @click="changeMode()"
          >แก้ไข</v-btn
        >
        <v-divider vertical class="mt-3" style="height: 40px;"></v-divider>
        <v-btn
          v-if="editMode === true"
          width="18%"
          class="button-color ma-2 mr-5"
          dark
          @click="dialogConfirmSubmit = true"
          >บันทึกข้อมูล</v-btn
        >
        <v-btn
          v-else-if="editMode === false && approveRole === 'Super Admin'"
          class="button-color ma-2 mr-5"
          dark
          @click="dialogConfirmDel = true"
          >ลบธุรกิจ</v-btn
        >
        <v-btn
          v-else-if="editMode === false && approveRole !== 'Super Admin'"
          class="button-color ma-2 mr-5"
          dark
          @click="dialogApproverCompany = true"
          >ยกเลิกธุรกิจ</v-btn
        >
      </v-col> -->
    </v-row>
    <v-form ref="form" v-model="valid" lazy-validation>
      <div>
        <v-expansion-panels accordion v-model="panel" multiple>
          <v-row dense>
            <!-- ข้อมูลธุรกิจองค์กร -->
            <v-col cols="12">
              <v-card class="pt-5 pr-3 pl-3" elevation="0" style="border-radius: 24px;">
                <v-card-title
                  class="ra-head-text-bold mb-4"
                >
                  ข้อมูลธุรกิจองค์กร
                </v-card-title>
                <v-card-subtitle>
                  <v-row class="">
                    <v-col cols="12" class="pl-5" v-if="editMode === false">
                        <p class="txt-head" style="margin-top: 0%; color: #333333;">
                        รูปแบบการลงทะเบียนธุรกิจ
                      </p>
                      <p class="txt-font-value" style="margin-top: 0%; color: #333333; font-weight: 400;">
                        {{ TypebusinessRegister || "-" }}
                      </p>
                    </v-col>
                    <v-col cols="12" class="pl-5 pb-0" v-else>
                      <span class="txt-font" style="font-weight: 700; color: #333333;">รูปแบบการลงทะเบียนธุรกิจ</span>
                      <v-radio-group
                        class="mt-4"
                        v-model="TypebusinessRegister"
                        row
                      >
                        <v-radio
                          color="#2BA197"
                          label="ลงทะเบียนธุรกิจฉบับย่อ"
                          value="ลงทะเบียนธุรกิจฉบับย่อ">
                        </v-radio>
                        <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              rounded
                              dark
                              icon
                              class=""
                            >
                            <v-icon color="#B3B6B7" class="ml-n8" small>mdi-alert-circle-outline</v-icon>
                            </v-btn>
                          </template>
                          <span class="label-table-action">Level Business 1-3</span>
                        </v-tooltip>
                         <v-radio
                          v-if="dataLevel > 2"
                          color="#2BA197"
                          label="ลงทะเบียนธุรกิจฉบับเต็ม"
                          value="ลงทะเบียนธุรกิจฉบับเต็ม"
                        ></v-radio>
                        <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }" v-if="dataLevel > 2">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              rounded
                              dark
                              icon
                              class=""
                            >
                            <v-icon color="#B3B6B7" class="ml-n8" small>mdi-alert-circle-outline</v-icon>
                            </v-btn>
                          </template>
                          <span class="label-table-action">Level Business 1-3</span>
                        </v-tooltip>
                      </v-radio-group>
                    </v-col>
                    <v-col cols="12" class="form-control pl-5" v-if="editMode === false">
                      <p class="txt-head" style="margin-top: -20px; color: #333333;">
                        รูปแบบธุรกิจ
                      </p>
                      <p class="txt-font-value" style="margin-top: 0%; color: #333333; font-weight: 400;">
                        {{ businessModelType || "-" }}
                      </p>
                    </v-col>
                    <v-col cols="12" class="pl-5 pb-0" v-else>
                      <span class="txt-font" style="font-weight: 700; color: #333333;">รูปแบบธุรกิจ</span>
                      <v-radio-group
                        class="mt-4"
                        v-model="businessModelType"
                        @change="getSelectbusinessType(businessModelType)"
                        row
                      >
                      <!-- ถ้าหลังบ้านแก้ api ให้ค่อยเปิดโค้คที่คอมเม้นไว้ด้านบน -->
                      <!-- <v-radio-group
                        class="mt-4"
                        v-model="businessModelType"
                        row
                      > -->
                        <v-radio
                          color="#2BA197"
                          label="กิจการ"
                          value="กิจการ"
                        ></v-radio>
                        <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              rounded
                              dark
                              icon
                              class=""
                            >
                            <v-icon color="#B3B6B7" class="ml-n8" small>mdi-alert-circle-outline</v-icon>
                            </v-btn>
                          </template>
                          <span class="label-table-action">Level Business 1-3</span>
                        </v-tooltip>
                        <v-radio
                          v-if="dataLevel > 2"
                          color="#2BA197"
                          label="นิติบุคคล"
                          value="นิติบุคคล">
                        </v-radio>
                        <v-tooltip bottom v-if="dataLevel > 2">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              rounded
                              dark
                              icon
                              class=""
                            >
                            <v-icon color="#B3B6B7" class="ml-n8" small>mdi-alert-circle-outline</v-icon>
                            </v-btn>
                          </template>
                          <span class="label-table-action">Level Business 1-3</span>
                        </v-tooltip>
                        <v-radio
                          v-if="dataLevel > 2"
                          color="#2BA197"
                          label="องค์กร"
                          value="องค์กร">
                        </v-radio>
                        <v-tooltip bottom v-if="dataLevel > 2">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              rounded
                              dark
                              icon
                              class=""
                            >
                            <v-icon color="#B3B6B7" class="ml-n8" small>mdi-alert-circle-outline</v-icon>
                            </v-btn>
                          </template>
                          <span class="label-table-action">Level Business 1-3</span>
                        </v-tooltip>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                  <v-divider class="mb-4" v-if="editMode === false"></v-divider>
                  <!-- รายละเอียดกิจการ -->
                  <v-layout
                    class="pa-2 pr-2"
                    v-show="businessModelType === 'กิจการ'"
                  >
                    <v-row>
                      <v-col cols="12">
                        <div v-if="editMode === true">
                        <span class="txt-head">รายละเอียดกิจการ</span>
                        <span class="txt-font ml-1" style="color: grey; font-size: 14px;">(โปรดกรอกข้อมูลที่มีเครื่องหมาย<span style="color: red;">*</span> ให้ครบถ้วน)</span>
                        </div>
                        <div v-else>
                        <span class="txt-head">รายละเอียดกิจการ</span>
                        </div>
                      </v-col>
                      <v-col cols="12" lg="8" md="8" sm="12" xs="12">
                        <v-row>
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ประเภทกิจการ ภาษาไทย<span v-if="editMode === true" style="color: red;">*</span>
                            </p>
                            <p
                              v-if="editMode === false"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ businessType || "-" }}
                            </p>
                            <v-autocomplete
                              v-else
                              v-model.trim="businessType"
                              :items="itemBusiness"
                              item-text="name"
                              placeholder="เลือกประเภทกิจการภาษาไทย"
                              dense
                              outlined
                              :rules="[v => !!v || 'กรุณาเลือกข้อมูลประเภทกิจการ']"
                              @change="changeBusinessTH(businessType)"
                              >
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control" v-if="businessType == 'อื่นๆโปรดระบุ'">
                            <p class="txt-font" style="margin-top: 0%;">
                             ระบุประเภทกิจการภาษาไทย<span v-if="editMode === true" style="color: red;">*</span>
                            </p>
                            <v-text-field
                              v-model.trim="otherTypeNamesTh"
                              placeholder="ระบุประเภทกิจการภาษาไทย"
                              :rules="[v => (!!v && v.length >=2) || 'กรุณากรอกข้อมูลประเภทกิจการ',
                                      (v) => {
                                            if (v && /^[ก-๏ ]+$/.test(v)) return true;
                                            else return 'กรุณาใช้ตัวอักษรภาษาไทยเท่านั้น';
                                          }
                                      ]"
                              dense
                              outlined
                              @keydown.space="preventLeadingSpace"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ประเภทกิจการ ภาษาอังกฤษ<span v-if="editMode === true" style="color: red;">*</span>
                            </p>
                            <p
                              v-if="editMode === false"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ businessTypeEng || "-" }}
                            </p>
                            <v-autocomplete
                              v-else
                              v-model="businessTypeEng"
                              :items="itemBusiness"
                              item-text="nameEn"
                              placeholder="เลือกประเภทกิจการภาษาอังกฤษ"
                              dense
                              outlined
                              :rules="[v => !!v || 'กรุณาเลือกข้อมูลประเภทกิจการ']"
                              @change="changeBusinessEng(businessTypeEng)"
                              >
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control" v-if="businessType == 'อื่นๆโปรดระบุ'">
                            <p class="txt-font" style="margin-top: 0%;">
                             ระบุประเภทกิจการภาษาอังกฤษ<span v-if="editMode === true" style="color: red;">*</span>
                            </p>
                            <v-text-field
                              v-model.trim="otherTypeNamesEng"
                              placeholder="ระบุประเภทกิจการภาษาอังกฤษ"
                              :rules="[v => (!!v && v.length >=2) || 'กรุณากรอกข้อมูลประเภทกิจการ',
                                      (v) => {
                                          if (v && /^[a-zA-Z() ]+$/.test(v)) return true;
                                          else return 'กรุณาใช้ตัวอักษรภาษาอังกฤษเท่านั้น';
                                        }]"
                              dense
                              outlined
                              @keydown.space="preventLeadingSpace"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ชื่อเต็มกิจการ ภาษาไทย<span v-if="editMode === true" style="color: red;">*</span>
                            </p>
                            <p
                              v-if="editMode === false"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ companyNameFullTh || "-" }}
                            </p>
                            <v-text-field
                              v-else
                              v-model.trim="companyNameFullTh"
                              placeholder="ระบุชื่อเต็มธุรกิจ ภาษาไทย"
                              :rules="[v => (!!v && v.length >=2) || 'กรุณากรอกข้อมูล',
                                      (v) => {
                                            if (v && /^[ก-๏ ]+$/.test(v)) return true;
                                            else return 'กรุณาใช้ตัวอักษรภาษาไทยเท่านั้น';
                                          }]"
                              dense
                              outlined
                              @keydown.space="preventLeadingSpace"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ชื่อย่อกิจการ ภาษาไทย (ไม่จำเป็น)
                            </p>
                            <p
                              v-if="editMode === false"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ companyNameShortTh || "-" }}
                            </p>
                            <v-text-field
                              v-else
                              v-model.trim="companyNameShortTh"
                              placeholder="ระบุชื่อย่อธุรกิจ ภาษาไทย"
                              dense
                              outlined
                              @keydown.space="preventLeadingSpace"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ชื่อเต็มกิจการ ภาษาอังกฤษ<span v-if="editMode === true" style="color: red;">*</span>
                            </p>
                            <p
                              v-if="editMode === false"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ companyNameFullEng || "-" }}
                            </p>
                            <v-text-field
                              v-else
                              v-model.trim="companyNameFullEng"
                              placeholder="ระบุชื่อเต็มกิจการ ภาษาอังกฤษ"
                              :rules="[v => (!!v && v.length >=2) || 'กรุณากรอกข้อมูล',
                                      (v) => {
                                          if (v && /^[a-zA-Z() ]+$/.test(v)) return true;
                                          else return 'กรุณาใช้ตัวอักษรภาษาอังกฤษเท่านั้น';
                                        }]"
                              dense
                              outlined
                              @keydown.space="preventLeadingSpace"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ชื่อย่อกิจการ ภาษาอังกฤษ (ไม่จำเป็น)
                            </p>
                            <p
                              v-if="editMode === false"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ companyNameShortEng || "-" }}
                            </p>
                            <v-text-field
                              v-else
                              v-model.trim="companyNameShortEng"
                              placeholder="ระบุชื่อย่อธุรกิจ ภาษาอังกฤษ"
                              dense
                              outlined
                              @keydown.space="preventLeadingSpace"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              เบอร์โทรศัพท์<span v-if="editMode === true" style="color: red;">*</span>
                            </p>
                            <p
                              v-if="editMode === false"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ companyTelNo || "-" }}
                            </p>
                            <v-text-field
                              v-else
                              v-model="companyTelNo"
                              placeholder="ระบุหมายเลขเบอร์โทรศัพท์"
                              type="number"
                              dense
                              outlined
                              maxlength="10"
                              :rules="[v => !!v || 'กรุณากรอกเบอร์โทรศัพท์ให้ครบ 10 หลัก',
                                      v => !(/[ ]/.test(v)) || 'กรุณากรอกข้อมูลที่ไม่มีเว้นวรรค',
                                      (v) => {
                                          if (v && /^[0-9 ]+$/.test(v)) return true;
                                          else return 'กรุณากรอกข้อมูลที่เป็นตัวเลขเท่านั้น';
                                        }]"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              อีเมล<span v-if="editMode === true" style="color: red;">*</span>
                            </p>
                            <p
                              v-if="editMode === false"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ email || "-" }}
                            </p>
                            <v-text-field
                              v-else
                              v-model.trim="email"
                              placeholder="ระบุอีเมล"
                              dense
                              outlined
                              :rules="[v => !!v || 'กรุณากรอกข้อมูล',
                                       v => /[a-zA-Z ].+@.+\..+/.test(v) || 'กรุณากรอกรูปแบบอีเมลให้ถูกต้อง']"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                      <!-- รูปภาพ -->
                      <v-col cols="12" lg="4" md="4" sm="12" xs="12">
                        <v-col cols="12" class="form-control ml-lg-15 mr-lg-15 ml-md-0 mr-md-0 ml-sm-0 mr-sm-0">
                          <p class="txt-font" style="margin-top: 0%;">รูปเครื่องหมายการค้าหรือโลโก้</p>
                            <div
                              v-if="editMode === false"
                              class="base-image-input elevation-0"
                              :style="{
                                'background-image': `url(${imageUrl})`
                              }"
                            >
                              <span v-if="!imageUrl" class="placeholder-image">
                              </span>
                              <input
                                class="file-input"
                                id="files"
                                ref="Pickfiles"
                                type="file"
                                accept="image/*"
                                v-on:change="onBannerSelected()"
                              />
                            </div>
                            <div
                                v-else
                                class="mt-8 base-image-input"
                                :style="{ 'background-image': `url(${imageUrl})` }"
                                @click="ChooseBanner()">
                                <span
                                  v-if="!imageUrl"
                                  class="placeholder-image">
                                </span>
                                <input
                                  class="file-input"
                                  id="files"
                                  ref="Pickfiles"
                                  type="file"
                                  v-on:change="onBannerSelected()">
                            </div>
                            <div class="pt-4 pl-16" v-show="editMode === true">
                                <v-btn outlined class="button-color-outline" v-if="imageUrl !== ''" @click="ChooseBanner()">
                                  <v-icon left>mdi-autorenew</v-icon>เปลี่ยนรูปภาพ
                                </v-btn>
                                <v-btn dark class="button-color" v-if="imageUrl === ''" @click="ChooseBanner()">อัปโหลดรูปภาพ</v-btn>
                            </div>
                        </v-col>
                      </v-col>
                    </v-row>
                  </v-layout>
                  <!-- รายละเอียดนิติบุคคล -->
                  <v-layout
                    class="pa-2 pr-2"
                    v-show="businessModelType === 'นิติบุคคล'"
                  >
                    <v-row>
                      <v-col cols="12">
                        <div v-if="editMode === true">
                        <span class="txt-head">รายละเอียดนิติบุคคล</span>
                        <span class="txt-font ml-1" style="color: grey; font-size: 14px;">(โปรดกรอกข้อมูลที่มีเครื่องหมาย<span style="color: red;">*</span> ให้ครบถ้วน)</span>
                        </div>
                        <div v-else>
                        <span class="txt-head">รายละเอียดนิติบุคคล</span>
                        </div>
                      </v-col>
                      <v-col cols="12" lg="8" md="8" sm="12" xs="12">
                        <v-row>
                          <!-- ประเภทนิติบุคคลภาษาไทย -->
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ประเภทนิติบุคคล ภาษาไทย<span v-if="editMode === true" style="color: red;">*</span>
                            </p>
                            <p
                              v-if="editMode === false"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ businessType || "-" }}
                            </p>
                            <v-autocomplete
                              v-else
                              v-model="businessType"
                              :items="itemlegalEntity"
                              item-text="name"
                              placeholder="เลือกประเภทนิติบุคคล"
                              :rules="[v => !!v || 'กรุณาเลือกข้อมูลประเภทนิติบุคคล']"
                              dense
                              outlined
                              @change="changeBusinessTH(businessType)"
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control" v-if="businessType == 'อื่นๆโปรดระบุ'">
                            <p class="txt-font" style="margin-top: 0%;">
                              ระบุประเภทนิติบุคคลภาษาไทย<span v-if="editMode === true" style="color: red;">*</span>
                            </p>
                            <v-text-field
                              v-model.trim="otherTypeNamesTh"
                              placeholder="ระบุประเภทนิติบุคคลภาษาไทย"
                              :rules="[v => (!!v && v.length >=2) || 'กรุณากรอกข้อมูลประเภทนิติบุคคล',
                                      (v) => {
                                            if (v && /^[ก-๏ ]+$/.test(v)) return true;
                                            else return 'กรุณาใช้ตัวอักษรภาษาไทยเท่านั้น';
                                          }
                                      ]"
                              dense
                              outlined
                              @keydown.space="preventLeadingSpace"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ประเภทนิติบุคคล ภาษาอังกฤษ<span v-if="editMode === true" style="color: red;">*</span>
                            </p>
                            <p
                              v-if="editMode === false"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ businessTypeEng || "-" }}
                            </p>
                            <v-autocomplete
                              v-else
                              v-model="businessTypeEng"
                              :items="itemlegalEntity"
                              item-text="nameEn"
                              placeholder="เลือกประเภทนิติบุคคลภาษาอังกฤษ"
                              :rules="[v => !!v || 'กรุณาเลือกข้อมูลประเภทนิติบุคคล']"
                              dense
                              outlined
                              @change="changeBusinessEng(businessTypeEng)"
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control" v-if="businessType == 'อื่นๆโปรดระบุ'">
                            <p class="txt-font" style="margin-top: 0%;">
                              ระบุประเภทนิติบุคคลภาษาอังกฤษ<span v-if="editMode === true" style="color: red;">*</span>
                            </p>
                            <v-text-field
                              v-model.trim="otherTypeNamesEng"
                              placeholder="ระบุประเภทนิติบุคคลภาษาอังกฤษ"
                              :rules="[v => (!!v && v.length >=2) || 'กรุณากรอกข้อมูลประเภทนิติบุคคล',
                                      (v) => {
                                          if (v && /^[a-zA-Z() ]+$/.test(v)) return true;
                                          else return 'กรุณาใช้ตัวอักษรภาษาอังกฤษเท่านั้น';
                                        }]"
                              dense
                              outlined
                              @keydown.space="preventLeadingSpace"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ชื่อเต็มบริษัท ภาษาไทย<span v-if="editMode === true" style="color: red;">*</span>
                            </p>
                            <p
                              v-if="editMode === false"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ companyNameFullTh || "-" }}
                            </p>
                            <v-text-field
                              v-else
                              v-model.trim="companyNameFullTh"
                              placeholder="ระบุชื่อเต็มบริษัท ภาษาไทย"
                              :rules="[v => (!!v && v.length >=2) || 'กรุณากรอกข้อมูล',
                                      (v) => {
                                            if (v && /^[ก-๏ ]+$/.test(v)) return true;
                                            else return 'กรุณาใช้ตัวอักษรภาษาไทยเท่านั้น';
                                          }]"
                              dense
                              outlined
                              @keydown.space="preventLeadingSpace"
                              @blur="newNameFormat('corporationTH')"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                              <p class="txt-font" style="margin-top: 0%;">
                                ชื่อย่อบริษัท ภาษาไทย (ไม่จำเป็น)
                              </p>
                              <p
                                v-if="editMode === false"
                                class="txt-font-value"
                                style="margin-top: 0%;"
                              >
                                {{ companyNameShortTh || "-" }}
                              </p>
                              <v-text-field
                                v-else
                                v-model.trim="companyNameShortTh"
                                placeholder="ระบุชื่อย่อบริษัท ภาษาไทย"
                                dense
                                outlined
                                @keydown.space="preventLeadingSpace"
                              ></v-text-field>
                          </v-col>
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ชื่อเต็มบริษัท ภาษาอังกฤษ<span v-if="editMode === true" style="color: red;">*</span>
                            </p>
                            <p
                              v-if="editMode === false"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ companyNameFullEng || "-" }}
                            </p>
                            <v-text-field
                              v-else
                              v-model.trim="companyNameFullEng"
                              placeholder="ระบุชื่อเต็มบริษัท ภาษาอังกฤษ"
                              :rules="[v => (!!v && v.length >=2) || 'กรุณากรอกข้อมูล',
                                      (v) => {
                                          if (v && /^[a-zA-Z() ]+$/.test(v)) return true;
                                          else return 'กรุณาใช้ตัวอักษรภาษาอังกฤษเท่านั้น';
                                        }]"
                              dense
                              outlined
                              @keydown.space="preventLeadingSpace"
                              @blur="newNameFormat('corporationENG')"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ชื่อย่อบริษัท ภาษาอังกฤษ (ไม่จำเป็น)
                            </p>
                            <p
                              v-if="editMode === false"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ companyNameShortEng || "-" }}
                            </p>
                            <v-text-field
                              v-else
                              v-model.trim="companyNameShortEng"
                              placeholder="ระบุชื่อย่อบริษัท ภาษาอังกฤษ"
                              dense
                              outlined
                              @keydown.space="preventLeadingSpace"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ชื่อสำหรับแสดงบนเอกสาร ภาษาไทย
                            </p>
                            <p
                              v-if="editMode === false"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ nameUseInDocTh || "-" }}
                            </p>
                            <v-text-field
                              v-else
                              v-model.trim="nameUseInDocTh"
                              disabled
                              placeholder="ชื่อสำหรับแสดงบนเอกสาร ภาษาไทย"
                              dense
                              outlined
                              background-color="#F5F5F5"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ชื่อสำหรับแสดงบนเอกสาร ภาษาอังกฤษ
                            </p>
                            <p
                              v-if="editMode === false"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ nameUseInDocEng || "-" }}
                            </p>
                            <v-text-field
                              v-else
                              v-model.trim="nameUseInDocEng"
                              disabled
                              placeholder="ชื่อสำหรับแสดงบนเอกสาร ภาษาอังกฤษ"
                              dense
                              outlined
                              background-color="#F5F5F5"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                      <!-- รูปภาพ -->
                      <v-col cols="12" lg="4" md="4" sm="12" xs="12">
                        <v-col cols="12" class="form-control ml-lg-15 mr-lg-15 ml-md-0 mr-md-0 ml-sm-0 mr-sm-0">
                          <p class="txt-font" style="margin-top: 0%;">รูปเครื่องหมายการค้าหรือโลโก้</p>
                            <div
                              v-if="editMode === false"
                              class="base-image-input elevation-0"
                              :style="{
                                'background-image': `url(${imageUrl})`
                              }"
                            >
                              <span v-if="!imageUrl" class="placeholder-image">
                              </span>
                              <input
                                class="file-input"
                                id="files"
                                ref="Pickfiles"
                                type="file"
                                accept="image/*"
                                v-on:change="onBannerSelected()"
                              />
                            </div>
                            <div
                                v-else
                                class="mt-8 base-image-input"
                                :style="{ 'background-image': `url(${imageUrl})` }"
                                @click="ChooseBanner()">
                                <span
                                  v-if="!imageUrl"
                                  class="placeholder-image">
                                </span>
                                <input
                                  class="file-input"
                                  id="files"
                                  ref="Pickfiles"
                                  type="file"
                                  v-on:change="onBannerSelected()">
                            </div>
                            <div class="pt-4 pl-16" v-show="editMode === true">
                                <v-btn outlined class="button-color-outline" v-if="imageUrl !== ''" @click="ChooseBanner()">
                                  <v-icon left>mdi-autorenew</v-icon>เปลี่ยนรูปภาพ
                                </v-btn>
                                <v-btn dark class="button-color" v-if="imageUrl === ''" @click="ChooseBanner()">อัปโหลดรูปภาพ</v-btn>
                            </div>
                        </v-col>
                      </v-col>
                    </v-row>
                  </v-layout>
                  <!-- รายละเอียดองค์กร -->
                  <v-layout
                    class="pa-2 pr-2"
                    v-show="businessModelType === 'องค์กร'"
                  >
                    <v-row>
                      <v-col cols="12">
                        <div v-if="editMode === true">
                        <span class="txt-head">รายละเอียดองค์กร</span>
                        <span class="txt-font ml-1" style="color: grey; font-size: 14px;">(โปรดกรอกข้อมูลที่มีเครื่องหมาย<span style="color: red;">*</span> ให้ครบถ้วน)</span>
                        </div>
                        <div v-else>
                        <span class="txt-head">รายละเอียดองค์กร</span>
                        </div>
                      </v-col>
                      <v-col cols="12" lg="8" md="8" sm="12" xs="12">
                        <v-row>
                          <!-- ประเภทองค์กรไทย  -->
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ประเภทองค์กร ภาษาไทย<span v-if="editMode === true" style="color: red;">*</span>
                            </p>
                            <p
                              v-if="editMode === false"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ businessType || "-" }}
                            </p>
                            <v-autocomplete
                              v-else
                              v-model="businessType"
                              :items="itemOrganization"
                              item-text="name"
                              placeholder="เลือกประเภทองค์กรภาษาไทย"
                              :rules="[v => !!v || 'กรุณาเลือกข้อมูลประเภทองค์กร']"
                              dense
                              outlined
                              @change="changeBusinessTH(businessType)"
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control" v-if="businessType == 'อื่นๆโปรดระบุ'">
                            <p class="txt-font" style="margin-top: 0%;">
                              ระบุประเภทองค์กรภาษาไทย<span v-if="editMode === true" style="color: red;">*</span>
                            </p>
                            <v-text-field
                              v-model.trim="otherTypeNamesTh"
                              placeholder="ระบุประเภทองค์กรภาษาไทย"
                              :rules="[v => (!!v && v.length >=2) || 'กรุณากรอกข้อมูลประเภทองค์กร',
                                      (v) => {
                                            if (v && /^[ก-๏ ]+$/.test(v)) return true;
                                            else return 'กรุณาใช้ตัวอักษรภาษาไทยเท่านั้น';
                                          }
                                      ]"
                              dense
                              outlined
                              @keydown.space="preventLeadingSpace"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ประเภทองค์กร ภาษาอังกฤษ<span v-if="editMode === true" style="color: red;">*</span>
                            </p>
                            <p
                              v-if="editMode === false"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ businessTypeEng || "-" }}
                            </p>
                            <v-autocomplete
                              v-else
                              v-model="businessTypeEng"
                              :items="itemOrganization"
                              item-text="nameEn"
                              placeholder="เลือกประเภทองค์กรภาษาอังกฤษ"
                              :rules="[v => !!v || 'กรุณาเลือกข้อมูลประเภทองค์กร']"
                              dense
                              outlined
                              @change="changeBusinessEng(businessTypeEng)"
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control" v-if="businessType == 'อื่นๆโปรดระบุ'">
                            <p class="txt-font" style="margin-top: 0%;">
                              ระบุประเภทองค์กรภาษาอังกฤษ<span v-if="editMode === true" style="color: red;">*</span>
                            </p>
                            <v-text-field
                              v-model.trim="otherTypeNamesEng"
                              placeholder="ระบุประเภทองค์กรภาษาอังกฤษ"
                              :rules="[v => (!!v && v.length >=2) || 'กรุณากรอกข้อมูลประเภทองค์กร',
                                      (v) => {
                                          if (v && /^[a-zA-Z() ]+$/.test(v)) return true;
                                          else return 'กรุณาใช้ตัวอักษรภาษาอังกฤษเท่านั้น';
                                        }]"
                              dense
                              outlined
                              @keydown.space="preventLeadingSpace"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ชื่อเต็มองค์กร ภาษาไทย<span v-if="editMode === true" style="color: red;">*</span>
                            </p>
                            <p
                              v-if="editMode === false"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ companyNameFullTh || "-" }}
                            </p>
                            <v-text-field
                              v-else
                              v-model.trim="companyNameFullTh"
                              placeholder="ระบุชื่อเต็มองค์กร ภาษาไทย"
                              :rules="[v => (!!v && v.length >=2) || 'กรุณากรอกข้อมูล',
                                      (v) => {
                                            if (v && /^[ก-๏ ]+$/.test(v)) return true;
                                            else return 'กรุณาใช้ตัวอักษรภาษาไทยเท่านั้น';
                                          }]"
                              dense
                              outlined
                              @keydown.space="preventLeadingSpace"
                              @blur="newNameFormat('organizationTH')"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ชื่อย่อองค์กร ภาษาไทย (ไม่จำเป็น)
                            </p>
                            <p
                              v-if="editMode === false"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ companyNameShortTh || "-" }}
                            </p>
                            <v-text-field
                              v-else
                              v-model.trim="companyNameShortTh"
                              placeholder="ระบุชื่อย่อองค์กร ภาษาไทย"
                              dense
                              outlined
                              @keydown.space="preventLeadingSpace"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ชื่อเต็มองค์กร ภาษาอังกฤษ<span v-if="editMode === true" style="color: red;">*</span>
                            </p>
                            <p
                              v-if="editMode === false"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ companyNameFullEng || "-" }}
                            </p>
                            <v-text-field
                              v-else
                              v-model.trim="companyNameFullEng"
                              placeholder="ระบุชื่อเต็มองค์กร ภาษาอังกฤษ"
                              :rules="[v => (!!v && v.length >=2) || 'กรุณากรอกข้อมูล',
                                      (v) => {
                                          if (v && /^[a-zA-Z() ]+$/.test(v)) return true;
                                          else return 'กรุณาใช้ตัวอักษรภาษาอังกฤษเท่านั้น';
                                        }]"
                              dense
                              outlined
                              @keydown.space="preventLeadingSpace"
                              @blur="newNameFormat('organizationENG')"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ชื่อย่อองค์กร ภาษาอังกฤษ (ไม่จำเป็น)
                            </p>
                            <p
                              v-if="editMode === false"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ companyNameShortEng || "-" }}
                            </p>
                            <v-text-field
                              v-else
                              v-model.trim="companyNameShortEng"
                              placeholder="ระบุชื่อย่อองค์กร ภาษาอังกฤษ"
                              dense
                              outlined
                              @keydown.space="preventLeadingSpace"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ชื่อสำหรับแสดงบนเอกสาร ภาษาไทย
                            </p>
                            <p
                              v-if="editMode === false"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ nameUseInDocTh || "-" }}
                            </p>
                            <v-text-field
                              v-else
                              v-model.trim="nameUseInDocTh"
                              disabled
                              placeholder="ชื่อสำหรับแสดงบนเอกสาร ภาษาไทย"
                              dense
                              outlined
                              background-color="#F5F5F5"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="form-control">
                            <p class="txt-font" style="margin-top: 0%;">
                              ชื่อสำหรับแสดงบนเอกสาร ภาษาอังกฤษ
                            </p>
                            <p
                              v-if="editMode === false"
                              class="txt-font-value"
                              style="margin-top: 0%;"
                            >
                              {{ nameUseInDocEng || "-" }}
                            </p>
                            <v-text-field
                              v-else
                              disabled
                              v-model.trim="nameUseInDocEng"
                              placeholder="ชื่อสำหรับแสดงบนเอกสาร ภาษาอังกฤษ"
                              dense
                              outlined
                              background-color="#F5F5F5"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                      <!-- รูปภาพ -->
                      <v-col cols="12" lg="4" md="4" sm="12" xs="12">
                        <v-col cols="12" class="form-control ml-lg-15 mr-lg-15 ml-md-0 mr-md-0 ml-sm-0 mr-sm-0">
                          <p class="txt-font" style="margin-top: 0%;">รูปเครื่องหมายการค้าหรือโลโก้</p>
                            <div
                              v-if="editMode === false"
                              class="base-image-input elevation-0"
                              :style="{
                                'background-image': `url(${imageUrl})`
                              }"
                            >
                              <span v-if="!imageUrl" class="placeholder-image">
                              </span>
                              <input
                                class="file-input"
                                id="files"
                                ref="Pickfiles"
                                type="file"
                                accept="image/*"
                                v-on:change="onBannerSelected()"
                              />
                            </div>
                            <div
                                v-else
                                class="mt-8 base-image-input"
                                :style="{ 'background-image': `url(${imageUrl})` }"
                                @click="ChooseBanner()">
                                <span
                                  v-if="!imageUrl"
                                  class="placeholder-image">
                                </span>
                                <input
                                  class="file-input"
                                  id="files"
                                  ref="Pickfiles"
                                  type="file"
                                  v-on:change="onBannerSelected()">
                            </div>
                            <div class="pt-4 pl-16" v-show="editMode === true">
                                <v-btn outlined class="button-color-outline" v-if="imageUrl !== ''" @click="ChooseBanner()">
                                  <v-icon left>mdi-autorenew</v-icon>เปลี่ยนรูปภาพ
                                </v-btn>
                                <v-btn dark class="button-color" v-if="imageUrl === ''" @click="ChooseBanner()">อัปโหลดรูปภาพ</v-btn>
                            </div>
                        </v-col>
                      </v-col>
                    </v-row>
                  </v-layout>
                  <v-divider class="" v-if="editMode === false"></v-divider>
                  <!-- ที่อยู่กิจการ/ที่อยู่นิติบุคคล/ที่อยู่องค์กร -->
                    <!-- <v-layout class="pr-2 pl-2 mt-3" v-show="TypebusinessRegister == 'ลงทะเบียนธุรกิจฉบับเต็ม'"> -->
                    <v-layout class="pr-2 pl-2 mt-3">
                    <v-row>
                      <v-col cols="12" class="from-control">
                        <span
                          class="txt-head"
                          style="font-size: 16px; color: #171F46;"
                          v-show="businessModelType === 'กิจการ'"
                          >ที่อยู่กิจการ</span
                        >
                        <span
                          class="txt-head"
                          style="font-size: 16px; color: #171F46;"
                          v-show="businessModelType === 'นิติบุคคล'"
                          >ที่อยู่นิติบุคคล</span
                        >
                        <span
                          class="txt-head"
                          style="font-size: 16px; color: #171F46;"
                          v-show="businessModelType === 'องค์กร'"
                          >ที่อยู่องค์กร</span
                        >
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12"  class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">
                          รหัสประจำที่อยู่
                        </p>
                        <p
                          v-if="editMode === false"
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ companyAddressDetail.codeAddress || "-" }}
                        </p>
                        <v-text-field
                          v-else
                          v-model.trim="companyAddressDetail.codeAddress"
                          placeholder="ระบุรหัสประจำที่อยู่"
                          type="number"
                          dense
                          outlined
                          @keydown.space="preventLeadingSpace"
                          :rules="[
                                      v => !(/[ ]/.test(v)) || 'กรุณากรอกข้อมูลที่ไม่มีเว้นวรรค',
                                      (v) => {
                                          if (v && /^[0-9 ]+$/.test(v)) return true;
                                          else return 'กรุณากรอกข้อมูลที่เป็นตัวเลขเท่านั้น';
                                        }]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12"  class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">ที่อยู่</p>
                        <p
                          v-if="editMode === false"
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ companyAddressDetail.address || "-" }}
                        </p>
                        <v-text-field
                          v-else
                          v-model.trim="companyAddressDetail.address"
                          placeholder="ระบุบ้านเลขที่"
                          dense
                          outlined
                          @keydown.space="preventLeadingSpace"
                          :rules="[(v) => {
                                          if (v && /^[0-9ก-๏/ ]+$/.test(v)) return true;
                                          else return 'กรุณากรอกข้อมูลที่เป็นตัวเลขเท่านั้น';
                                        }]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">
                          เลขที่ห้อง
                        </p>
                        <p
                          v-if="editMode === false"
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ companyAddressDetail.roomNo || "-" }}
                        </p>
                        <v-text-field
                          v-else
                          v-model.trim="companyAddressDetail.roomNo"
                          placeholder="ระบุเลขที่ห้อง"
                          dense
                          outlined
                           @keydown.space="preventLeadingSpace"
                          :rules="[(v) => {
                                          if (v && /^[0-9 ]+$/.test(v)) return true;
                                          else return 'กรุณากรอกข้อมูลที่เป็นตัวเลขเท่านั้น';
                                        }]"
                        ></v-text-field>
                      </v-col>
                      <!-- อาคาร ชั้น = ต้องเปลี่ยนตัวแปรใหม่เพราะมันเอา 2 key มารวมกันจากเดิมที่แยกกัน ชั้น=floorNo อาคาร=buildingName-->
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12"  class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">อาคาร, ชั้น</p>
                        <p
                          v-if="editMode === false"
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ companyAddressDetail.floorNo || "-" }}
                        </p>
                        <v-text-field
                          v-else
                          v-model.trim="companyAddressDetail.floorNo"
                          placeholder="ระบุอาคาร, ชั้นที่"
                          dense
                          outlined
                        ></v-text-field>
                      </v-col>
                      <!-- <v-col cols="4" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">อาคาร</p>
                        <p
                          v-if="editMode === false"
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ companyAddressDetail.buildingName || "-" }}
                        </p>
                        <v-text-field
                          v-else
                          v-model="companyAddressDetail.buildingName"
                          label="ระบุอาคาร, ชั้นที่"
                          dense
                          outlined
                        ></v-text-field>
                      </v-col> -->
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12"  class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">หมู่บ้าน</p>
                        <p
                          v-if="editMode === false"
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ companyAddressDetail.villageName || "-" }}
                        </p>
                        <v-text-field
                          v-else
                          v-model.trim="companyAddressDetail.villageName"
                          placeholder="ระบุหมู่บ้าน"
                          dense
                          outlined
                          @keydown.space="preventLeadingSpace"
                          :rules="[(v) => {
                                        if (v && /^[ ก-๏ ]+$/.test(v)) return true;
                                        else return 'กรุณาใช้ตัวอักษรภาษาไทยเท่านั้น';
                                  }]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12"  class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">หมู่ที่</p>
                        <p
                          v-if="editMode === false"
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ companyAddressDetail.villageNo || "-" }}
                        </p>
                        <v-text-field
                          v-else
                          v-model.trim="companyAddressDetail.villageNo"
                          placeholder="ระบุหมู่ที่"
                          dense
                          outlined
                          @keydown.space="preventLeadingSpace"
                          :rules="[(v) => {
                                          if (v && /^[0-9 ]+$/.test(v)) return true;
                                          else return 'กรุณากรอกข้อมูลที่เป็นตัวเลขเท่านั้น';
                                  }]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12"  class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">ตรอก/ซอย</p>
                        <p
                          v-if="editMode === false"
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ companyAddressDetail.alley || "-" }}
                        </p>
                        <v-text-field
                          v-else
                          v-model.trim="companyAddressDetail.alley"
                          placeholder="ระบุตรอก/ซอย"
                          dense
                          outlined
                          @keydown.space="preventLeadingSpace"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12"  class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">แยก</p>
                        <p
                          v-if="editMode === false"
                          class="txt-font"
                          style="margin-top: 0%;"
                        >
                          {{ companyAddressDetail.dispart || "-" }}
                        </p>
                        <v-text-field
                          v-else
                          v-model.trim="companyAddressDetail.dispart"
                          placeholder="ระบุแยก"
                          dense
                          outlined
                          @keydown.space="preventLeadingSpace"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12"  class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">ถนน</p>
                        <p
                          v-if="editMode === false"
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ companyAddressDetail.road || "-" }}
                        </p>
                        <v-text-field
                          v-else
                          v-model.trim="companyAddressDetail.road"
                          placeholder="ระบุถนน"
                          dense
                          outlined
                          @keydown.space="preventLeadingSpace"
                        ></v-text-field>
                      </v-col>
                      <!-- จังหวัด -->
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12"  class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">จังหวัด</p>
                        <p
                          v-if="editMode === false"
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ companyAddressDetail.province || "-" }}
                        </p>
                        <v-autocomplete
                          v-else
                          v-model.trim="companyAddressDetail.province"
                          :items="$store.state.province_th_list"
                          placeholder="ระบุจังหวัด"
                          dense
                          outlined
                          @change="Countycheck ()"
                        ></v-autocomplete>
                      </v-col>
                      <!-- อำเภอ -->
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12"  class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">
                          อำเภอ/เขต
                        </p>
                        <p
                          v-if="editMode === false"
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ companyAddressDetail.district || "-" }}
                        </p>
                        <v-autocomplete
                          v-else
                          v-model="companyAddressDetail.district"
                          :items="listamphoe"
                          placeholder="ระบุอำเภอ/เขต"
                          dense
                          outlined
                          @change="Districtcheck()"
                        ></v-autocomplete>
                      </v-col>
                      <!-- ตำบล -->
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12"  class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">
                          ตำบล/แขวง
                        </p>
                        <p
                          v-if="editMode === false"
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ companyAddressDetail.subDistrict || "-" }}
                        </p>
                        <v-autocomplete
                          v-else
                          v-model="companyAddressDetail.subDistrict"
                          :items="listdistrict"
                          placeholder="ระบุตำบล/แขวง"
                          dense
                          outlined
                          @change="Zibcodecheck()"
                        ></v-autocomplete>
                        <!-- <v-text-field
                          v-else
                          v-model="companyAddressDetail.subDistrict"
                          label="ตำบล/แขวง"
                          :rules="inputRules"
                          dense
                          outlined
                        ></v-text-field> -->
                      </v-col>
                      <!-- รหัสไปรษณีย์ -->
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12"  class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">
                          รหัสไปรษณีย์
                        </p>
                        <p
                          v-if="editMode === false"
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ companyAddressDetail.postCode || "-" }}
                        </p>
                        <v-text-field
                          v-else
                          v-model="companyAddressDetail.postCode"
                          placeholder="รหัสไปรษณีย์"
                          type="number"
                          dense
                          background-color="#F5F5F5"
                          outlined
                          disabled
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-layout>
                </v-card-subtitle>
                <v-divider class="mr-5 ml-5" v-if="editMode === false && TypebusinessRegister == 'ลงทะเบียนธุรกิจฉบับเต็ม'"></v-divider>
                <!-- ข้อมูลผู้เสียภาษี -->
                <v-card-title
                  class="ra-head-text-bold pr-8 mb-3"
                  style="font-size: 16px; padding-left:24px;color: #171F46;"
                  v-show="TypebusinessRegister == 'ลงทะเบียนธุรกิจฉบับเต็ม'"
                >
                  <div v-if="editMode === true">
                    ข้อมูลผู้เสียภาษี
                    <span class="txt-font ml-1" style="color: grey; font-size: 14px;">(โปรดกรอกข้อมูลที่มีเครื่องหมาย<span style="color: red;">*</span> ให้ครบถ้วน)</span>
                  </div>
                  <div v-else>
                    ข้อมูลผู้เสียภาษี
                  </div>
                </v-card-title>
                <v-card-subtitle v-show="TypebusinessRegister == 'ลงทะเบียนธุรกิจฉบับเต็ม'">
                  <v-row class="">
                    <div class="pl-5">
                      <span v-if="editMode === false" class="txt-font-value">{{
                        taxDetailType
                      }}</span>
                      <v-radio-group
                        v-else
                        v-model="taxDetailType"
                        row
                      >
                        <v-radio
                          color="#2BA197"
                          label="ไม่มีข้อมูลผู้เสียภาษี"
                          value="ไม่มีข้อมูลผู้เสียภาษี"
                        ></v-radio>
                        <v-radio
                          color="#2BA197"
                          label="มีข้อมูลผู้เสียภาษี"
                          value="มีข้อมูลผู้เสียภาษี"
                        ></v-radio>
                      </v-radio-group>
                    </div>
                  </v-row>
                  <v-layout
                    class="pa-2 pr-2"
                    v-show="taxDetailType === 'มีข้อมูลผู้เสียภาษี'"
                  >
                    <v-row>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">
                          เลขที่ผู้เสียภาษีอากร<span v-if="editMode === true" style="color: red;">*</span>
                        </p>
                        <p
                          v-if="editMode === false"
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ taxId || "-" }}
                        </p>
                        <v-text-field
                          v-else
                          v-model="taxId"
                          placeholder="ระบุเลขที่ผู้เสียภาษีอากร"
                          maxlength="13"
                          :rules="[v => !!v || 'กรุณากรอกเลขที่ผู้เสียภาษีอากรให้ครบ 13 หลัก',
                                      v => !(/[ ]/.test(v)) || 'กรุณากรอกข้อมูลที่ไม่มีเว้นวรรค',
                                      v => v.length >= 13 || 'กรุณากรอกเลขที่ผู้เสียภาษีอากรให้ครบ 13 หลัก',
                                      (v) => {
                                          if (v && /^[0-9 ]+$/.test(v)) return true;
                                          else return 'กรุณากรอกข้อมูลที่เป็นตัวเลขเท่านั้น';
                                        }]"
                          dense
                          outlined
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">อีเมล<span v-if="editMode === true" style="color: red;">*</span></p>
                        <p
                          v-if="editMode === false"
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ email || "-" }}
                        </p>
                        <v-text-field
                          v-else
                          v-model="email"
                          placeholder="ระบุอีเมล"
                          dense
                          outlined
                          :rules="[v => !!v || 'กรุณากรอกข้อมูล',
                                   v => /[a-zA-Z ].+@.+\..+/.test(v) || 'กรุณากรอกรูปแบบอีเมลให้ถูกต้อง']"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">
                          ภูมิภาค/Region<span v-if="editMode === true" style="color: red;">*</span>
                        </p>
                        <p
                          v-if="editMode === false"
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ region || "-" }}
                        </p>
                        <v-select
                          v-else
                          v-model="region"
                          :items="[
                            'ภาคเหนือ',
                            'ภาคตะวันออกเฉียงเหนือ',
                            'ภาคกลาง',
                            'ภาคใต้'
                          ]"
                          placeholder="ระบุภูมิภาค"
                          dense
                          outlined
                          :rules="inputRules"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">
                          ชื่อสาขา<span v-if="editMode === true">(กรณีไม่มีกรุณาระบุเป็น สำนักงานใหญ่)</span><span v-if="editMode === true" style="color: red;">*</span>
                        </p>
                        <p
                          v-if="editMode === false"
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ branchName || "-" }}
                        </p>
                        <v-text-field
                          v-else
                          v-model.trim="branchName"
                          placeholder="ระบุรหัสสาขา"
                          dense
                          outlined
                          @keydown.space="preventLeadingSpace"
                          :rules="[v => (!!v && v.length >=2) || 'กรุณากรอกข้อมูลชื่อสาขา']"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">
                          รหัสสาขา<span v-if="editMode === true"> (กรณีไม่มีกรุณาระบุเป็น 00001)</span><span v-if="editMode === true" style="color: red;">*</span>
                        </p>
                        <p
                          v-if="editMode === false"
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ branchCode || "-" }}
                        </p>
                        <v-text-field
                          v-else
                          v-model.trim="branchCode"
                          placeholder="ระบุสาขา"
                          dense
                          outlined
                          :rules="[v => !!v || 'กรุณากรอกข้อมูล',
                                   v => !(/[ ]/.test(v)) || 'กรุณากรอกข้อมูลที่ไม่มีเว้นวรรค',
                                   (v) => {
                                          if (v && /^[0-9 ]+$/.test(v)) return true;
                                          else return 'กรุณากรอกข้อมูลที่เป็นตัวเลขเท่านั้น';
                                  }]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">
                          เบอร์โทรศัพท์ (ไม่จำเป็น)
                        </p>
                        <p
                          v-if="editMode === false"
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ companyTelNo || "-" }}
                        </p>
                        <v-text-field
                          v-else
                          v-model="companyTelNo"
                          placeholder="ระบุเบอร์โทรศัพท์"
                          dense
                          outlined
                          maxlength="10"
                          :rules="[
                                   v => v.length >= 10 || 'กรุณากรอกเบอร์มือถือไม่เกิน 10 หลัก',
                                   (v) => {
                                          if (v && /^[0-9]+$/.test(v)) return true;
                                          else return 'กรุณากรอกข้อมูลที่เป็นตัวเลขเท่านั้น';
                                  }]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">
                          เบอร์ติดต่อเจ้าหน้าที่<span v-if="editMode === true" style="color: red;">*</span>
                        </p>
                        <p
                          v-if="editMode === false"
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ companyMobilNumber || "-" }}
                        </p>
                        <v-text-field
                          v-else
                          v-model="companyMobilNumber"
                          placeholder="ระบุเบอร์ติดต่อเจ้าหน้าที่"
                          dense
                          outlined
                          :rules="[v => !!v || 'กรุณากรอกเบอร์ติดต่อเจ้าหน้าที่ไม่เกิน 10 หลัก',
                                   v => !(/[ ]/.test(v)) || 'กรุณากรอกข้อมูลที่ไม่มีเว้นวรรค',
                                   v => v.length >= 10 || 'กรุณากรอกเบอร์ติดต่อเจ้าหน้าที่ไม่เกิน 10 หลัก',
                                   (v) => {
                                          if (v && /^[0-9 ]+$/.test(v)) return true;
                                          else return 'กรุณากรอกข้อมูลที่เป็นตัวเลขเท่านั้น';
                                  }]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="4" md="4" sm="6" xs="12" class="form-control">
                        <p class="txt-font" style="margin-top: 0%;">โทรสาร (ไม่จำเป็น)</p>
                        <p
                          v-if="editMode === false"
                          class="txt-font-value"
                          style="margin-top: 0%;"
                        >
                          {{ fax || "-" }}
                        </p>
                        <v-text-field
                          v-else
                          v-model.trim="fax"
                          placeholder="ระบุเบอร์โทรสาร"
                          dense
                          outlined
                          maxlength="9"
                          @keydown.space="preventLeadingSpace"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-layout>
                </v-card-subtitle>
                <v-divider class="ml-5 mr-5" v-if="editMode === false && TypebusinessRegister == 'ลงทะเบียนธุรกิจฉบับเต็ม'"></v-divider>
                <!-- เอกสารที่ต้องแนบ(หนังสือรับรอง) -->
                <v-card-title
                  class="ra-head-text-bold pr-8"
                  style="font-size: 16px; padding-left:24px;color: #171F46;"
                >
                <span v-if="editMode === false && TypebusinessRegister == 'ลงทะเบียนธุรกิจฉบับเต็ม'">เอกสารที่ต้องแนบ</span>
                <span v-if="editMode === true && TypebusinessRegister == 'ลงทะเบียนธุรกิจฉบับเต็ม'">เอกสารที่ต้องแนบ
                    <span class="ml-1"></span>
                    <span class="txt-font" style="color: grey; font-size: 14px;">&nbsp;
                      </span><span style="color: red;">*</span>
                        <span class="txt-font" style="color: grey; font-size: 14px;">โปรดแนบเอกสารให้ตรงกับข้อมูลที่กรอก</span>
                  </span>
                </v-card-title>
                <v-card-subtitle v-show="TypebusinessRegister == 'ลงทะเบียนธุรกิจฉบับเต็ม'">
                  <v-row>
                    <div class="pl-5 pt-3">
                      <span v-if="editMode === false" class="txt-font-value">{{
                        docsDetailType
                      }}</span>
                      <v-radio-group
                        v-else
                        v-model="docsDetailType"
                        @change="checkConfirmDocsDetailType(docsDetailType)"
                        row
                      >
                        <v-radio
                          color="#2BA197"
                          label="ไม่มีหนังสือรับรอง"
                          value="ไม่มีหนังสือรับรอง"
                        ></v-radio>
                        <v-radio
                          color="#2BA197"
                          label="มีหนังสือรับรอง"
                          value="มีหนังสือรับรอง"
                        ></v-radio>
                      </v-radio-group>
                    </div>
                  </v-row>
                  <v-layout v-if="editMode === false">
                    <v-row>
                      <v-col cols="4" md="3" sm="3" lg="4" xl="3" class="pl-5" v-show="docsDetailType === 'มีหนังสือรับรอง'">
                          <p class="txt-font" style="margin-top: 0%;">
                              หนังสือรับรองนิติบุคคล
                            </p>
                            <div class="mt-1">
                              <v-row>
                                <v-col cols="12">
                                  <!-- มีไฟล์ -->
                                  <v-btn
                                    v-if="filesCertificateName"
                                    id="btnbrowse"
                                    name="btnbrowse"
                                    outlined
                                    dark
                                    class="button-color-outline pa-2 align-center"
                                    @click="
                                        downloadFile(
                                          filesCertificateId,
                                          filesCertificateName
                                        )
                                    "
                                  >
                                    <v-icon left small class="icon-eye-color">mdi-tray-arrow-down</v-icon>
                                    <span class="text-sub-color">{{
                                      filesCertificateName
                                    }}</span>
                                  </v-btn>
                                  <!-- ไม่มีไฟล์ -->
                                  <span v-else class="txt-font">-</span>
                                </v-col>
                                <!-- <v-col cols="6">
                                  <p class="txt-font" style="margin-top: 0%;">รหัสเอกสาร</p>
                                  <p
                                    v-if="editMode === false"
                                    class="txt-font-value"
                                    style="margin-top: 0%;"
                                  >
                                    {{ documentId || "-" }}
                                  </p>
                                </v-col>
                                <v-col cols="6">
                                  <p class="txt-font" style="margin-top: 0%;">รหัสผ่านของเอกสาร</p>
                                  <p
                                    v-if="editMode === false"
                                    class="txt-font-value"
                                    style="margin-top: 0%;"
                                  >
                                    {{ password || "-" }}
                                  </p>
                                </v-col> -->
                              </v-row>
                            </div>
                            <div v-if="!checkboxpoa">
                              <span class="txt-font">ไม่มีผู้ดำเนินการแทน</span>
                            </div>
                           <div v-if="checkboxpoa">
                            <p class="txt-font mt-2">
                              หนังสือมอบอำนาจ
                            </p>
                            <div class="mt-1">
                              <v-row>
                                <v-col cols="12">
                                  <v-btn
                                    v-if="poaName"
                                    id="btnbrowse"
                                    name="btnbrowse"
                                    outlined
                                    dark
                                    class="button-color-outline pa-2 align-center"
                                    @click="
                                        downloadFile(
                                          poaId,
                                          poaName
                                        )
                                    "
                                  >
                                    <v-icon left small class="icon-eye-color">mdi-tray-arrow-down</v-icon>
                                    <span class="text-sub-color">{{
                                      poaName
                                    }}</span>
                                  </v-btn>
                                  <span v-else class="txt-font">-</span>
                               </v-col>
                              </v-row>
                            </div>
                           </div>
                      </v-col>
                    </v-row>
                  </v-layout>
                  <v-layout v-else
                    class="pa-2 pr-2"
                    v-show="docsDetailType === 'มีหนังสือรับรอง'"
                  >
                    <v-row>
                      <v-col cols="12" lg="4" xl="4" md="4" sm="6" xs="12">
                            <p class="txt-font" style="margin-top: 0%;">
                              หนังสือรับรองนิติบุคคล <span style="color: red;">*</span>
                            <span class="txt-font" style="color: grey; font-size: 14px;">(โปรดแนบหนังสือรับรอง)</span>
                            </p>
                             <div class="box-image3 mt-0">
                              <v-row>
                                <v-col cols="7">
                                  <span
                                    v-if="filesCertificate.length === 0"
                                    class="text-right ml-5"
                                    style="color: #999999; font-size: 13px; margin-top: 0%;"
                                    >อัปโหลดหนังสือรับรอง</span
                                  >
                                  <input
                                    type="file"
                                    id="files"
                                    ref="PickfilesCertificate"
                                    accept=".pdf"
                                    multiple
                                    hidden
                                    v-on:change="onFileSelected('certificate')"
                                  />
                                  <div
                                    v-for="(file, key) in filesCertificate"
                                    :name="file.name"
                                    class="file-listing ml-1 mt-0"
                                    :key="key"
                                  >
                                    <v-chip
                                      close
                                      :id="key"
                                      :name="file.name"
                                      @click:close="removeFile(key, 'certificate')"
                                      class="mt-n3"
                                      ><span class="txt-limit">{{
                                        file.name
                                      }}</span
                                      >&nbsp;</v-chip
                                    >
                                  </div>
                                </v-col>
                                <v-col cols="2">
                                  <v-btn
                                    id="btnbrowse"
                                    name="btnbrowse"
                                    dark
                                    depressed
                                    color="#F8F9FA"
                                    class="ml-16 mb-0 mt-n3"
                                    small
                                    v-on:click="addFiles('certificate')"
                                    readOnly
                                  >
                                    <span
                                      class="txt-font"
                                      style="color: #2BA197; font-size:12px"
                                      >เลือกไฟล์</span
                                    >
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </div>
                            <v-progress-linear
                              v-show="loadingFile === true"
                              indeterminate
                              color="cyan darken-0"
                            ></v-progress-linear>
                            <p class="txt-font" style="margin-top: 5%;">
                              อัปโหลดได้เฉพาะไฟล์ .pdf เท่านั้น
                            </p>
                            <v-row v-if="filesCertificate.length !== 0">
                              <v-col
                                cols="6"
                                class="form-control"
                              >
                                <p class="txt-font" style="margin-top: 0%;">
                                  รหัสเอกสาร
                                </p>
                                <v-text-field
                                  v-model.trim="documentId"
                                  placeholder="ระบุรหัสเอกสาร"
                                  dense
                                  outlined
                                  @keydown.space="preventLeadingSpace"
                                ></v-text-field>
                              </v-col>
                              <v-col
                                cols="6"
                                class="form-control"
                              >
                                <p class="txt-font" style="margin-top: 0%;">
                                  รหัสผ่านของเอกสาร
                                </p>
                                <v-text-field
                                  v-model.trim="password"
                                  placeholder="ระบุรหัสผ่านเอกสาร"
                                  dense
                                  outlined
                                  @keydown.space="preventLeadingSpace"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                           <v-checkbox
                              v-model="checkboxpoa"
                              color="#2BA197"
                              label="กรณีเป็นผู้ดำเนินการแทน กรุณาแนบหนังสือมอบอำนาจด้วย"
                           ></v-checkbox>
                           <div v-if="checkboxpoa">
                            <p class="txt-font" style="margin-top: 0%;">
                              หนังสือมอบอำนาจ <span style="color: red;">*</span>
                            <span class="txt-font" style="color: grey; font-size: 14px;">(โปรดแนบหนังสือมอบอำนาจ)</span>
                            </p>
                            <div class="box-image3 mt-1">
                              <v-row>
                                <v-col cols="7">
                                <span v-if="filesPoa.length === 0" class="text-right ml-5" style="color: #999999; font-size: 13px; margin-top: 0%;">อัปโหลดหนังสือมอบอำนาจ</span>
                                <input type="file" id="files" accept=".pdf" hidden ref="PickfilesPoa" multiple v-on:change="onFileSelected('poa')"/>
                                <div v-for="(file, key) in filesPoa" :name="file.name" class="file-listing ml-1 mt-0" :key="key">
                                  <v-chip close :id="key" :name="file.name" @click:close="removeFile(key, 'poa')" class="mt-n3"><span class="txt-limit">{{ file.name }}</span>&nbsp;</v-chip>
                                </div>
                              </v-col>
                              <v-col cols="2">
                                <v-btn
                                  id="btnbrowse"
                                  name="btnbrowse"
                                  dark
                                  depressed
                                  color="#F8F9FA"
                                  class="ml-16 mb-0 mt-n3"
                                  small
                                  v-on:click="addFiles('poa')"
                                  readOnly
                                >
                                  <span
                                    class="txt-font"
                                    style="color: #2BA197; font-size:12px"
                                    >เลือกไฟล์</span
                                  >
                                </v-btn>
                              </v-col>
                                <v-col cols="1">
                                </v-col>
                                <v-col cols="2" lg="2" md="2" sm="2">
                                <v-btn
                                  id="btnbrowse"
                                  name="btnbrowse"
                                  outlined
                                  dark
                                  class="button-color-outline mt-n3 ml-16"
                                  @click="getFormPoa()"
                                >
                                  <v-icon left dark class="icon-eye-color">mdi-tray-arrow-down</v-icon>
                                  <span class="txt-font" style="font-weight: 500; font-size: 14px; color:#2BA197">แบบฟอร์มหนังสือมอบอำนาจ.doc</span>
                                </v-btn>
                                </v-col>
                              </v-row>
                            </div>
                            <p class="txt-font" style="margin-top: 5%;">
                              อัปโหลดได้เฉพาะไฟล์ .pdf เท่านั้น
                            </p>
                           </div>
                      </v-col>
                    </v-row>
                  </v-layout>
                </v-card-subtitle>
                <v-divider class="ml-5 mr-5" v-if="editMode === false"></v-divider>
                <!-- ข้อมูลผู้ดูแล -->
                <v-card-title
                  class="ra-head-text-bold pr-8"
                  style="font-size: 16px; padding-left:24px;color: #171F46;"
                >
                  ข้อมูลผู้ดูแล
                  <v-spacer></v-spacer>
                  <v-btn
                    v-show="editMode === true"
                    v-if="approver.length !== 0"
                    text
                    class="button-color-outline mb-2"
                    @click="openDialogAddAprover('add', '', '', 'approver')"
                  >
                    <v-icon left dark class="icon-eye-color" size="14px"
                      >fa-plus</v-icon
                    >
                    <span class="ra-text-in-button-business">
                      เพิ่มผู้ดูแล
                    </span>
                  </v-btn>
                </v-card-title>
                <v-card-subtitle>
                  <v-row
                    v-if="approver.length === 0"
                    class="mt-0 mb-8"
                    justify="center"
                  >
                    <v-col cols="8" class="text-center">
                      <img
                        width="150"
                        height="110"
                        src="@/assets/icons/emp-data-icon2.png"
                      />
                    </v-col>
                    <v-col
                      cols="8"
                      class="text-center"
                      style="margin-top: -1%;"
                    >
                      <span class="" style="font-weight: bold;"
                        >ยังไม่มีข้อมูลผู้ดูแล</span
                      >
                    </v-col>
                    <v-col
                      cols="8"
                      class="text-center"
                      style="margin-top: -1%;"
                    >
                      <span v-if="editMode === true" class="ra-head-text"
                        >คลิกที่ปุ่มด้านล่างนี้เพื่อเพิ่มผู้ดูแลของคุณ</span
                      >
                    </v-col>
                    <v-col
                      v-if="editMode === true"
                      cols="8"
                      class="pt-0 pb-0 d-flex align-center justify-center mt-4"
                      style="margin-top: -1%;"
                    >
                      <v-btn
                        class="button-color pl-8 pr-8"
                        style="border-radius: 6px;"
                        dark
                        depressed
                        @click="openDialogAddAprover('add', '', '', 'approver')"
                      >
                        <v-icon left dark color="#fff" size="14px"
                          >fa-plus</v-icon
                        >
                        <span class="ra-text-in-button">
                          เพิ่มผู้ดูแล
                        </span>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row v-else>
                    <v-col cols="12">
                      <v-data-table
                        :hide-default-footer="true"
                        :headers="editMode === false ? headers : headersEdit"
                        :items="approver"
                        sort-by="no"
                        class="elevation-0"
                      >
                        <template v-slot:[`item.no`]="{ item }">
                          {{ approver.indexOf(item) + 1 }}
                        </template>
                        <!-- <template v-slot:top>
                    <v-toolbar
                      flat
                      v-show="editMode === true"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        class="mb-2"
                        @click="openDialogAddAprover('add', '', '', 'approver')"
                      >
                      <v-icon left dark color="primary" size="14px">fa-plus</v-icon>
                      <span class="ra-text-in-button">
                        เพิ่มผู้ดูแล
                      </span>
                      </v-btn>
                    </v-toolbar>
                  </template> -->
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                rounded
                                small
                                dark
                                icon
                                class="mt-3 mb-3"
                                @click="
                                  openDialogAddAprover(
                                    'edit',
                                    item,
                                    approver.indexOf(item),
                                    'approver'
                                  )
                                "
                              >
                                <template v-slot>
                                  <v-icon dark small class="icon-eye-color"
                                    >mdi-pencil-outline</v-icon
                                  >
                                </template>
                              </v-btn>
                            </template>
                            <span class="label-table-action"
                              >จัดการผู้ดูแล</span
                            >
                          </v-tooltip>
                          <v-tooltip bottom v-show="editMode === true">
                            <template v-slot:activator="{on, attrs }">
                              <!-- <v-btn
                                v-if="approver.indexOf(item) + 1 === 1"
                                v-bind="attrs"
                                v-on="on"
                                rounded
                                dark
                                small
                                color="#F5F5F5"
                                icon
                                class="mt-3 mb-3 ml-2"
                              >
                                <template v-slot>
                                  <v-icon color="#DADADA" small
                                    >mdi-delete-outline</v-icon
                                  >
                                </template>
                              </v-btn> -->
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                rounded
                                dark
                                small
                                icon
                                class="mt-3 mb-3 ml-2"
                                @click="checkRemove(item, 'approver')"
                              >
                                <template v-slot>
                                  <v-icon color="error" small
                                    >mdi-delete-outline</v-icon
                                  >
                                </template>
                              </v-btn>
                            </template>
                            <span class="label-table-action">ลบผู้ดูแล</span>
                          </v-tooltip>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-card-subtitle>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <!-- ดาวน์โหลดแบบฟอร์ม -->
            <!-- <v-col cols="12" v-show="businessModelType === 'นิติบุคคล'">
              <span class="txt-head"
                >ดาวน์โหลดแบบฟอร์ม<span class="ml-1"></span
                ><span class="txt-font" style="color: grey; font-size: 14px;"
                  >&nbsp;(</span
                ><span style="color: red;">*</span
                ><span class="txt-font" style="color: grey; font-size: 14px;"
                  >กรุณาดาวน์โหลดแบบฟอร์มในการกรอกข้อมูลเพื่อใช้ในการเพิ่มผู้รักษาการ)</span
                ></span
              >
            </v-col>
            <v-col cols="6" v-show="businessModelType === 'นิติบุคคล'">
              <v-btn
                id="btnbrowse"
                name="btnbrowse"
                right
                rounded
                color="#FFFFFF"
                dark
                class="mr-2 ml-2 pa-5 align-center btn_click"
                @click="getFormAuth()"
              >
                <v-icon left dark color="#6B96F8">fa-file-alt</v-icon>
                <span class="txt-font">แบบฟอร์มหนังสือมอบอำนาจ.doc</span>
                <v-icon right dark color="#6B96F8">fa-download</v-icon>
              </v-btn>
              <v-btn
                id="btnbrowse"
                name="btnbrowse"
                right
                rounded
                color="#FFFFFF"
                dark
                class="mr-0 ml-2 pa-5 align-center btn_click"
                @click="getFormPoa()"
              >
                <v-icon left dark color="#6B96F8">fa-file-alt</v-icon>
                <span class="txt-font">แบบฟอร์มหนังสือมอบอำนาจช่วง.doc</span>
                <v-icon right dark color="#6B96F8">fa-download</v-icon>
              </v-btn>
            </v-col> -->
            <!-- QR code -->
            <!-- <v-col
              cols="5"
              class="pt-0 pb-0 d-flex align-center justify-end mt-0 button-qr"
              style=""
            >
              <div class="text-center" style="border-radius: 5px">
                <v-menu
                  offset-y
                  v-model="menuQrcode"
                  :close-on-content-click="false"
                  :nudge-width="300"
                  :nudge-top="-10"
                  :nudge-right="-55"
                  max-width="250"
                  origin="right"
                  tile
                  z-index="10"
                  transition="slide-y-transition"
                  top
                  left
                >
                  <template v-slot:activator="{ on: menu, attrs }">
                    <v-tooltip left>
                      <template v-slot:activator="{ on: tooltip }">
                        <v-btn
                          v-bind="attrs"
                          v-on="{ ...tooltip, ...menu }"
                          class="mx-2"
                          fab
                          dark
                          color="#3776E9"
                        >
                          <v-icon dark>
                            mdi-qrcode-scan
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>สแกน QRCODE</span>
                    </v-tooltip>
                  </template>
                  <v-card style="border-radius: 5px;" class="mr-0">
                    <v-btn
                      absolute
                      right
                      top
                      icon
                      x-small
                      @click="menuQrcode = false"
                      ><v-icon>mdi-close</v-icon></v-btn
                    >
                    <v-row class="mt-0 mb-0" justify="center" align="center">
                      <v-col cols="8" class="text-right">
                        <p
                          class=""
                          style="font-weight: bold; font-size: 14px; margin-bottom: -1%"
                        >
                          สแกนเพื่อเข้าร่วมกับบริษัท
                        </p>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <div
                              v-bind="attrs"
                              v-on="on"
                              class="base-image-qrcode elevation-1 mx-1"
                              :style="{
                                'background-image': `url(${imageQrcode})`
                              }"
                            >
                              <span
                                v-if="!imageQrcode"
                                class="placeholder-image"
                              >
                              </span>
                              <input
                                class="file-input"
                                id="files"
                                ref="Pickfiles"
                                type="file"
                                v-on:change="onBannerSelected()"
                              />
                            </div>
                          </template>
                          <span class="txt-font" style="color: white;"
                            >QRCODE ของบริษัท</span
                          >
                        </v-tooltip>
                      </v-col>
                      <v-col
                        cols="8"
                        class="text-right"
                        style="margin-top: -6%; margin-right: -3%;"
                      >
                        <span
                          class=""
                          style="font-weight: bold; font-size: 14px; color: #3776E9; cursor: pointer;"
                          @click="getFormAuth()"
                          >ดาวน์โหลด QRCODE
                          <v-icon style="color: #3776E9">mdi-download</v-icon>
                        </span>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-menu>
              </div>
            </v-col> -->
          </v-row>
          <v-row v-show="editMode == true">
            <v-col cols="12" class="pa-0">
              <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                width="8%"
                class="button-color-outline ma-0"
                outlined
                @click="cancel()"
                >ยกเลิก</v-btn>
                <v-btn
                v-if="submitDataChk === false"
                width="8%"
                class="ma-2 mr-2"
                color="grey"
                depressed
                disabled
                >บันทึก</v-btn>
              <v-btn
                v-else
                width="8%"
                class="button-color ma-2 mr-5"
                dark
                @click="dialogConfirmSubmit = true"
                >บันทึก</v-btn>
                </v-card-actions>
            </v-col>
          </v-row>
        </v-expansion-panels>
      </div>
    </v-form>
    <v-dialog v-model="dialogDeleteApprover" max-width="400px">
      <v-card height="200px" style="border-radius: 12px;" class="pt-3 pb-5">
        <v-card-title class="ra-head-text-bold justify-center pa-5"
          >ต้องการลบข้อมูลนี้ ใช่หรือไม่?</v-card-title
        >
        <v-card-text class="justify-center text-center">
          <span
            v-if="titleDialog === 'approver'"
            class="ra-head-text justify-center"
            style="font-size: 16px;"
            >คุณแน่ใจหรือว่าต้องการลบข้อมูลผู้ดูแลคนนี้</span
          >
          <span
            v-else-if="titleDialog === 'temporaryer'"
            class="ra-head-text justify-center"
            style="font-size: 16px;"
            >คุณแน่ใจหรือว่าต้องการลบข้อมูลผู้รักษาการคนนี้</span
          >
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn
            class="pl-4 pr-4 mr-3"
            style="border-radius: 6px;"
            color="#2BA197"
            outlined
            @click="dialogDeleteApprover = false"
            >ยกเลิก</v-btn
          >
          <v-btn
            class="pl-4 pr-4"
            style="border-radius: 6px;"
            color="#2BA197"
            dark
            @click="removeApprover(itemConfirmDelete, titleDialog)"
            >ลบข้อมูล</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirmSubmit" max-width="400px">
      <v-card height="190px" style="border-radius: 12px;" class="pt-3">
        <v-card-title class="ra-head-text-bold text-sub-color justify-center pa-5"
          >บันทึกข้อมูลการแก้ไข</v-card-title
        >
        <v-card-text class="justify-center text-center">
          <span class="ra-head-text justify-center" style="font-size: 16px"
            >คุณแน่ใจหรือไม่ว่าต้องการบันทึกการแก้ไขข้อมูลธุรกิจ</span
          >
          <!-- <span v-else-if="titleDialog === 'temporaryer'" class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลผู้รักษาการคนนี้</span> -->
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn
            class="button-color-outline pl-4 pr-4 mr-3"
            style="border-radius: 6px;"
            outlined
            @click="dialogConfirmSubmit = false"
            >ทำรายการต่อ</v-btn
          >
          <v-btn
            class="button-color pl-4 pr-4"
            style="border-radius: 6px;"
            dark
            depressed
            @click="submitDataCreate()"
            >บันทึกการแก้ไข</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirmDel" max-width="400px">
      <v-card height="180px" style="border-radius: 12px;">
        <v-card-title class="ra-head-text-bold justify-center pa-5"
          >ต้องการลบข้อมูลนี้ใช่ไหม</v-card-title
        >
        <v-card-text class="justify-center text-center">
          <span class="ra-head-text justify-center" style="font-size: 16px;"
            >คุณแน่ใจหรือไม่ว่าต้องการลบข้อมูล</span
          >
          <!-- <span v-else-if="titleDialog === 'temporaryer'" class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลผู้รักษาการคนนี้</span> -->
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn
            class="pl-4 pr-4 mr-3"
            color="#2BA197"
            outlined
            @click="dialogConfirmDel = false"
            >ยกเลิก</v-btn
          >
          <v-btn
            class="pl-4 pr-4"
            color="#2BA197"
            dark
            @click="deleteBusiness()"
            >ยืนยัน</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogApproverCompany"
      persistent
      max-width="420"
      max-height="232"
    >
      <v-card tile class="justify-center">
        <v-card-title class="ra-head-text-bold justify-center pa-5"
          >ต้องการยกเลิกเอกสารนี้ใช่หรือไม่</v-card-title
        >
        <v-card-text class="justify-center text-center">
          <span class="ra-head-text justify-center"
            >คุณแน่ใจหรือไม่ว่าต้องการยกเลิกเอกสารนี้</span
          >
          <!-- <span v-else-if="titleDialog === 'temporaryer'" class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลผู้รักษาการคนนี้</span> -->
          <v-textarea
            v-model="comment"
            class="ml-8 mr-8"
            outlined
            rows="2"
            placeholder="ระบุความเห็น"
          ></v-textarea>
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn
            class="ra-button1"
            color="#1654C6"
            outlined
            @click="(dialogApproverCompany = false), (comment = '')"
            >ยกเลิก</v-btn
          >
          <v-btn
            v-if="comment === ''"
            class="ra-button1"
            color="grey"
            depressed
            disabled
            >ยืนยัน</v-btn
          >
          <v-btn
            v-else
            class="ra-button1"
            color="#1654C6"
            dark
            @click="updateStatusApprove('ยกเลิก')"
            >ยืนยัน</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogChangeVer" max-width="550px" persistent>
      <v-card>
        <v-card-title class="ra-head-text-bold justify-center pa-5"
          >ต้องการเปลี่ยนเวอร์ชั่นข้อมูลธุรกิจใช่ไหม</v-card-title
        >
        <v-card-text class="justify-center text-center">
          <span class="ra-head-text justify-center" style="font-size: 16px;"
            >คุณแน่ใจหรือไม่ว่าต้องการเปลี่ยนเวอร์ชั่นข้อมูลธุรกิจ</span
          >
        </v-card-text>
        <v-card-text class="justify-center text-center">
          <v-btn
            class="ra-button1 mb-3"
            width="70%"
            color="#1654C6"
            dark
            @click="submitDataCreate()"
            >ฉันแน่ใจ และบันทึกข้อมูล</v-btn
          >
          <v-btn
            class="ra-button1 mb-3"
            width="70%"
            color="#1654C6"
            outlined
            @click="getDetailVersion(versionDate)"
            >ฉันแน่ใจ และไม่บันทึกข้อมูล
          </v-btn>
          <v-btn
            class="ra-button1 mb-3"
            width="70%"
            color="#757575"
            text
            outlined
            dark
            @click="cancelVersion()"
            >ยกเลิก</v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- dialog ยืนยันเปลี่ยนข้อมูลภาษี -->
    <v-dialog v-model="dialogConfirmTaxDetail" max-width="510px">
      <v-card height="180px">
        <v-card-title class="ra-head-text-bold justify-center pa-5"
        style="font-weight: 700; font-size: 18px;"
          >ต้องการเปลี่ยนตัวเลือกเป็นไม่มีข้อมูลผู้เสียภาษีใช่หรือไม่</v-card-title
        >
        <v-card-text class="justify-center text-center">
          <span class="ra-head-text justify-center"
          style="font-size: 16px;"
            >หากกดยืนยันข้อมูลผู้เสียภาษีที่กรอกไว้จะถูกลบ</span
          >
          <!-- <span v-else-if="titleDialog === 'temporaryer'" class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลผู้รักษาการคนนี้</span> -->
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn
            class="ra-button1 pl-5 pr-5 mr-4"
            color="#2BA197"
            outlined
            @click="
              (dialogConfirmTaxDetail = false),
                (taxDetailType = 'มีข้อมูลผู้เสียภาษี')
            "
            >ยกเลิก</v-btn
          >
          <v-btn
            class="ra-button1 pl-5 pr-5"
            color="#2BA197"
            dark
            @click="confirmTaxDetailType()"
            >ยืนยัน</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
     <!-- เปลี่ยนตัวเลือกเอกสารที่ต้องแนบ -->
    <v-dialog v-model="dialogConfirmDocsDetail" max-width="530px">
      <v-card height="180px">
        <v-card-title
          class="ra-head-text-bold icon-eye-color justify-center pa-5"
          style="font-weight: 700; font-size: 18px;"
          >ต้องการเปลี่ยนตัวเลือกเป็นไม่มีหนังสือรับรองใช่หรือไม่</v-card-title
        >
        <v-card-text class="justify-center text-center">
          <span class="ra-head-text justify-center"
            style="font-size: 16px;"
            >หากกดยืนยันข้อมูลเอกสารที่เลือกไว้จะถูกลบ</span
          >
          <!-- <span v-else-if="titleDialog === 'temporaryer'" class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลผู้รักษาการคนนี้</span> -->
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn
            class="ra-button1 pl-5 pr-5 mr-4"
            color="#2BA197"
            outlined
            @click="
              (dialogConfirmDocsDetail = false),
                (docsDetailType = 'มีหนังสือรับรอง')
            "
            >ยกเลิก</v-btn
          >
          <v-btn
            class="ra-button1 pl-5 pr-5"
            color="#2BA197"
            dark
            @click="confirmDocsDetailType()"
            >ยืนยัน</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        :color="snackbarColor"
        text
        top
        app
      >
        <v-icon left dark small :color="snackbarColor">fa-check-circle</v-icon>
        <span :style="{ color: `${snackbarColor}` }">{{ text }}</span>
      </v-snackbar>
    </div>
    <DialogAddAprover />
    <OverlayLoading :loading="loading" />
  </div>
</template>

<script>
import swal from 'sweetalert'
import { EventBus } from '@/EventBus'
import FileSaver from 'file-saver'
import OverlayLoading from '../../_template/OverlayLoading.vue'
import DialogAddAprover from '../_dialog/dialogAddApprover'
import moment from 'moment'
import {
  // getUserByLogin,
  deleteBusinessById,
  updateBusinessNew // บันทึก
} from '@/API/API'
import Datazibcode from '../province_amphure_district/dataall.json'

const axios = require('axios')

export default {
  components: {
    DialogAddAprover,
    OverlayLoading
  },
  name: 'overview',
  data () {
    return {
      loadingFile: false,
      loadingFilePoa: false,
      dataLevel: localStorage.Level,
      loading: false,
      snackbar: false,
      timeout: 2000,
      snackbarColor: '',
      text: '',
      menuQrcode: false,
      dialogDeleteApprover: false, // dialog ลบข้อมูล
      dialogConfirmSubmit: false, // dialog บันทึกข้อมูล
      dialogConfirmDel: false, // dialog ลบข้อมูลธุรกิจ
      dialogApproverCompany: false, // dialog ยกเลิกธุรกิจ
      dialogConfirmTaxDetail: false, // dialog เปลี่ยนแปลงตัวเลือกผู้เสียภาษี
      dialogConfirmDocsDetail: false, // dialog เปลี่ยนแปลงตัวเลือกหนังสือรับรอง
      dialogChangeVer: false, // dialog เปลี่ยนเวอร์ชั่นข้อมูลธุรกิจ
      itemDetailOld: [],
      itemDetail: [],
      comment: '',
      titleDialog: '',
      itemConfirmDelete: [],
      editMode: false,
      panel: [0, 1],
      businessModelType: 'กิจการ', // รูปแบบธุรกิจ
      TypebusinessRegister: 'ลงทะเบียนธุรกิจฉบับย่อ', // รูปแบบการลงทะเบียน
      taxDetailType: 'ไม่มีข้อมูลผู้เสียภาษี', // รูปแบบผู้เสียภาษี
      docsDetailType: 'ไม่มีหนังสือรับรอง', // รูปแบบหนังสือรับรอง
      businessType: '', // ประเภทกิจการ,ประเภทนิติบุคคล,ประเภทองค์กร (th)
      businessTypeEng: '', // ประเภทกิจการ,ประเภทนิติบุคคล,ประเภทองค์กร (eng)
      idbusinessTypeTh: '', // ประเภทกิจการ,ประเภทนิติบุคคล,ประเภทองค์กร (th)
      idbusinessTypeEng: '', // ประเภทกิจการ,ประเภทนิติบุคคล,ประเภทองค์กร (eng)
      otherTypeNamesTh: '', // ชื่อประเภทอื่นๆ (th)
      otherTypeNamesEng: '', // ชื่อประเภทอื่นๆ (eng)
      reqBusinessId: '',
      // ตัวเลือกกิจการ (ถ้าหลังบ้านแก้ไขข้อมูลให้แล้งค่อยลบข้อมูลข้างในออก)
      itemBusiness: [],
      // ตัวเลือกนิติบุคคล (ถ้าหลังบ้านแก้ไขข้อมูลให้แล้งค่อยลบข้อมูลข้างในออก)
      itemlegalEntity: [],
      // ตัวเลือกองค์กร (ถ้าหลังบ้านแก้ไขข้อมูลให้แล้งค่อยลบข้อมูลข้างในออก)
      itemOrganization: [],
      statusList: [
        { status: 'pending', statusTH: 'รอการอนุมัติ', color: '#E9A016' },
        { status: 'approved', statusTH: 'อนุมัติแล้ว', color: '#58A144' },
        { status: 'reject', statusTH: 'ไม่อนุมัติ', color: '#D1392B' },
        { status: 'cancel', statusTH: 'ยกเลิก', color: '#D1392B' },
        { status: 'acknowledge', statusTH: 'รับทราบแล้ว', color: '#58A144' }
      ],
      status: '',
      approveRole: localStorage.approveRole,
      itemVersion: [],
      versionDate: '',
      versionDateOld: '',
      chkDataEmp: 0,
      imageData: null,
      // legalEntityEng: '', // ประเภทนิติบุคคลไทย
      // legalEntityTh: '', // ประเภทนิติบุคคลอังกฤษ
      nameUseInDocTh: '', // ชื่อสำหรับแสดงบนเอกสารภาษาไทย
      nameUseInDocEng: '', // ชื่อสำหรับแสดงบนเอกสารอังกฤษ
      groupName: '',
      companyNameEng: '',
      companyNameTh: '',
      itemCompany: [],
      taxId: '', // เลขที่ผู้เสียภาษีอากร
      email: '', // อีเมลรายละเอียด
      // taxemail: '', // อีเมลภาษี
      branchName: '', // ชื่อสาขา
      branchCode: '', // รหัสสาขา
      companyTelNo: '', // เบอร์โทรศัพท์รายละเอียด
      // taxTelNo: '', // เบอร์โทรศัพท์ภาษี
      companyMobilNumber: '',
      fax: '',
      // ข้อมูลที่อยู่
      companyAddressDetail: {
        codeAddress: '', // รหัสประจำที่อยู่
        address: '', // ที่อยู่
        roomNo: '', // เลขที่ห้อง
        floorNo: '', // ชั้น,อาคาร
        buildingName: '', // อาคาร
        villageName: '', // หมู่บ้าน
        villageNo: '', // หมู่ที่
        alley: '', // ตรอก/ซอย
        dispart: '', // แยก
        road: '', // ถนน
        province: '', // จังหวัด
        district: '', // อำเภอ
        subDistrict: '', // ตำบล แขวง
        postCode: '' // รหัสไปรษณีย์
      },
      region: '', // ภูมิภาค
      companyNameFullEng: '', // ชื่อเต็มภาษาอังกฤษ
      companyNameFullTh: '', // ชื่อเต็มภาษาไทย
      companyNameShortEng: '', // ชื่อย่อภาษาอังกฤษ
      companyNameShortTh: '', // ชื่อย่อภาษาไทย
      files: [], // รูปภาพ
      filesCertificate: [], // หนังสือรับรอง
      filesPoa: [], // หนังสือมอบอำนาจช่วง
      filesCertificateId: '',
      filesCertificateName: '',
      poaId: '',
      poaName: '',
      tel: '',
      img: '',
      tab: null,
      imageUrl: '',
      imageQrcode: '',
      checkboxpoa: false,
      type_files: [
        'pdf',
        'png',
        'jpg',
        'jpeg',
        'tiff',
        'gif',
        'rar',
        'zip',
        '7z'
      ],
      userDataStore: '',
      tokenUser: '',
      userIdList: [],
      userIdListTemporary: [],
      approver: [],
      temporaryer: [],
      isSelecting: false,
      valid: true,
      progressColor: '',
      progressValue: '',
      inputRules: [v => !!v || 'กรุณากรอกข้อมูล'],
      headers: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'no',
          width: '6%'
        },
        // { text: 'รูป', value: 'userImg' },
        // { text: 'รหัสพนักงาน', value: 'employeeId' },
        { text: 'ชื่อ-นามสกุล', value: 'approverName' },
        // { text: 'ตำแหน่ง', value: 'position' },
        { text: 'อีเมล', value: 'email' },
        { text: 'เบอร์โทรศัพท์', value: 'tel' }
      ],
      headersEdit: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'no',
          width: '6%'
        },
        { text: 'ชื่อ-นามสกุล', value: 'approverName', width: '32%' },
        { text: 'อีเมล', value: 'email', width: '32%' },
        { text: 'เบอร์โทรศัพท์', value: 'tel', width: '20%' },
        { text: 'จัดการ', value: 'actions', sortable: false, show: false, width: '10%' }
      ],
      headersTemporary: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'no'
        },
        { text: 'รูป', value: 'userImg' },
        { text: 'รหัสพนักงาน', value: 'employeeId' },
        { text: 'ชื่อ-นามสกุล', value: 'approverName' },
        { text: 'ตำแหน่ง', value: 'position' },
        { text: 'อีเมล', value: 'email' },
        { text: 'วันที่รักษาการ', value: '' },
        { text: 'เอกสาร', value: '' },
        { text: 'จัดการ', value: 'actions', sortable: false }
      ],
      listamphoe: [], // ข้อมูลอำเภอ
      listdistrict: [], // ข้อมูลตำบล
      getStatus: '',
      getId: '',
      getstatusEdit: false,
      statusChange: false,
      password: '', // รหัสผ่านเอกสาร
      documentId: '' // รหัสเอกสาร
    }
  },
  mounted () {
    EventBus.$on('addAprover', this.add)
  },
  beforeDestroy () {
    EventBus.$off('addAprover')
  },
  async created () {
    this.loading = true
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    this.propsitems = this.$route.params.id
    this.reqBusinessId = this.$route.params.id
    this.getstatusEdit = this.$route.params.statusedit
    this.getStatus = this.$route.params.status
    if (!this.$store.state.token) {
      this.goBack()
    } else {
      if (this.getstatusEdit) {
        this.editMode = true
      }
      this.getSelectCompany()
      await this.getCompanyDetail(this.propsitems)
      this.getSelectbusinessType(this.businessModelType) // api แก้แล้วค่อยเปิด
      this.getDataAll()
      this.Districtcheck()
      this.Zibcodecheck()
    }
  },
  computed: {
    // checkCopy () {
    //   if (this.versionDate !== this.itemVersion[this.itemVersion.length - 1]._id) return false
    //   return true
    // }
    // เช็คเงื่อนไขการกรอกข้อมูล
    submitDataChk () {
      if (this.businessModelType === 'กิจการ' && this.TypebusinessRegister === 'ลงทะเบียนธุรกิจฉบับเต็ม') {
        if (
          this.businessType === '' ||
          this.companyNameFullTh === '' ||
          this.companyNameFullEng === '' ||
          this.companyTelNo === '' ||
          this.email === '' ||
          (this.taxDetailType === 'มีข้อมูลผู้เสียภาษี' && (this.taxId === '' || this.email === '' || this.region === '' || this.branchName === '' || this.branchCode === '' || this.companyMobilNumber === '')) ||
          (this.docsDetailType === 'มีหนังสือรับรอง' && this.filesCertificate.length === 0) ||
          (this.checkboxpoa === true && this.filesPoa.length === 0)
        ) {
          return false
        } else {
          return true
        }
      } else if (this.businessModelType === 'นิติบุคคล' && this.TypebusinessRegister === 'ลงทะเบียนธุรกิจฉบับเต็ม') {
        if (
          this.businessType === '' ||
          this.companyNameFullTh === '' ||
          this.companyNameFullEng === '' ||
          (this.taxDetailType === 'มีข้อมูลผู้เสียภาษี' && (this.taxId === '' || this.email === '' || this.region === '' || this.branchName === '' || this.branchCode === '' || this.companyMobilNumber === '')) ||
          (this.docsDetailType === 'มีหนังสือรับรอง' && this.filesCertificate.length === 0) ||
          (this.checkboxpoa === true && this.filesPoa.length === 0)
        ) {
          return false
        } else {
          return true
        }
      } else if (this.businessModelType === 'องค์กร' && this.TypebusinessRegister === 'ลงทะเบียนธุรกิจฉบับเต็ม') {
        if (
          this.businessType === '' ||
          this.companyNameFullTh === '' ||
          this.companyNameFullEng === '' ||
          (this.taxDetailType === 'มีข้อมูลผู้เสียภาษี' && (this.taxId === '' || this.email === '' || this.region === '' || this.branchName === '' || this.branchCode === '' || this.companyMobilNumber === '')) ||
          (this.docsDetailType === 'มีหนังสือรับรอง' && this.filesCertificate.length === 0) ||
          (this.checkboxpoa === true && this.filesPoa.length === 0)
        ) {
          return false
        } else {
          return true
        }
      } else if (this.businessModelType === 'กิจการ' && this.TypebusinessRegister === 'ลงทะเบียนธุรกิจฉบับย่อ') {
        if (this.businessType === '' || this.companyNameFullTh === '' || this.companyNameFullEng === '' || this.companyTelNo === '') {
          return false
        } else {
          return true
        }
      } else if (this.businessModelType === 'นิติบุคคล' && this.TypebusinessRegister === 'ลงทะเบียนธุรกิจฉบับย่อ') {
        if (this.businessType === '' ||
          this.companyNameFullTh === '' ||
          this.companyNameFullEng === '') {
          return false
        } else {
          return true
        }
      } else {
        if (this.businessType === '' ||
          this.companyNameFullTh === '' ||
          this.companyNameFullEng === '') {
          return false
        } else {
          return true
        }
      }
    }
    // สิ้นสุด
  },
  watch: {
  },
  methods: {
    // ป้องกันการกรอก Spacebar
    preventLeadingSpace (e) {
      // ป้องกันการกด spacebar ถ้ายังไม่มีการกรอกข้อมูล
      if (!e.target.value) e.preventDefault()
      // ถ้าหากอักขระนำหน้าเป็นช่องว่าง ให้ลบช่องว่างนำหน้าทั้งหมดออก
      else if (e.target.value[0] === ' ') e.target.value = e.target.value.replace(/^\s*/, '')
    },
    getDataAll () {
      for (let i = 0; i < Datazibcode.length; i++) {
        const element = Datazibcode[i]
        if (this.companyAddressDetail.province === element.province) { // เช็ดค่าถ้าจังหวัดที่เลือกมาตรงกับจังหวัดที่มีใน data ไหม ถ้าตรงให้เก็บค่าไว้ใน listamphoe
          this.listamphoe.push(element.amphoe)
        }
      }
    },
    // เปลี่ยนรูปแบบชื่อบนเอกสาร
    newNameFormat (type) {
      if (this.businessModelType === 'นิติบุคคล') {
        if (type === 'corporationTH') {
          if (this.businessType === 'บริษัทจำกัด') {
            this.nameUseInDocTh = 'บริษัท ' + this.companyNameFullTh + ' จำกัด'
          } else if (this.businessType === 'บริษัทมหาชนจำกัด') {
            this.nameUseInDocTh = 'บริษัท ' + this.companyNameFullTh + ' จำกัด (มหาชน)'
          } else {
            this.nameUseInDocTh = this.businessType + ' ' + this.companyNameFullTh
          }
        } else {
          if (this.businessTypeEng === 'Company Limited') {
            this.nameUseInDocEng = this.companyNameFullEng + ' Co., Ltd.'
          } else if (this.businessTypeEng === 'Public Company Limited') {
            this.nameUseInDocEng = this.companyNameFullEng + ' Pub Co., Ltd.'
          } else if (this.businessTypeEng === 'Ordinary Partnership') {
            this.nameUseInDocEng = this.companyNameFullEng + ' Co.'
          } else if (this.businessTypeEng === 'Partnership Limited') {
            this.nameUseInDocEng = this.companyNameFullEng + ' Part., Ltd.'
          } else {
            this.nameUseInDocEng = this.companyNameFullEng + ' ' + this.businessTypeEng
          }
        }
      } else if (this.businessModelType === 'องค์กร') {
        if (type === 'organizationTH') {
          this.nameUseInDocTh = this.businessType + ' ' + this.companyNameFullTh
        } else {
          this.nameUseInDocEng = this.companyNameFullEng + ' ' + this.businessTypeEng
        }
      }
    },
    // เลือกประเภทไทย
    changeBusinessTH (name) {
      if (this.businessModelType === 'กิจการ') {
        this.itemBusiness.forEach((element) => {
          if (element.name === name) {
            this.businessTypeEng = element.nameEn
            this.idbusinessTypeEng = element._id
            this.idbusinessTypeTh = element._id
            this.statusChange = false
          }
        })
      } else if (this.businessModelType === 'นิติบุคคล') {
        this.itemlegalEntity.forEach((element) => {
          if (element.name === name) {
            this.businessTypeEng = element.nameEn
            this.idbusinessTypeEng = element._id
            this.idbusinessTypeTh = element._id
            if (this.businessType === 'บริษัทจำกัด') {
              this.nameUseInDocTh = 'บริษัท ' + this.companyNameFullTh + ' จำกัด'
            } else if (this.businessType === 'บริษัทมหาชนจำกัด') {
              this.nameUseInDocTh = 'บริษัท ' + this.companyNameFullTh + ' จำกัด (มหาชน)'
            } else {
              this.nameUseInDocTh = this.businessType + ' ' + this.companyNameFullTh
            }
            if (this.businessTypeEng === 'Company Limited') {
              this.nameUseInDocEng = this.companyNameFullEng + ' Co., Ltd.'
            } else if (this.businessTypeEng === 'Public Company Limited') {
              this.nameUseInDocEng = this.companyNameFullEng + ' Pub Co., Ltd.'
            } else if (this.businessTypeEng === 'Ordinary Partnership') {
              this.nameUseInDocEng = this.companyNameFullEng + ' Co.'
            } else if (this.businessTypeEng === 'Partnership Limited') {
              this.nameUseInDocEng = this.companyNameFullEng + ' Part., Ltd.'
            } else {
              this.nameUseInDocEng = this.companyNameFullEng + ' ' + this.businessTypeEng
            }
            this.statusChange = true
          }
        })
      } else {
        this.itemOrganization.forEach((element) => {
          if (element.name === name) {
            this.businessTypeEng = element.nameEn
            this.idbusinessTypeEng = element._id
            this.idbusinessTypeTh = element._id
            this.nameUseInDocTh = this.businessType + ' ' + this.companyNameFullTh
            this.nameUseInDocEng = this.companyNameFullEng + ' ' + this.businessTypeEng
            // this.nameUseInDocTh = ''
            // this.nameUseInDocEng = ''
            this.statusChange = true
          }
        })
      }
    },
    // เลือกประเภทอังกฤษ
    changeBusinessEng (name) {
      if (this.businessModelType === 'กิจการ') {
        this.itemBusiness.forEach((element) => {
          if (element.nameEn === name) {
            this.businessType = element.name
            this.idbusinessTypeTh = element._id
            this.idbusinessTypeEng = element._id
            this.statusChange = false
          }
        })
      } else if (this.businessModelType === 'นิติบุคคล') {
        this.itemlegalEntity.forEach((element) => {
          if (element.nameEn === name) {
            this.businessType = element.name
            this.idbusinessTypeTh = element._id
            this.idbusinessTypeEng = element._id
            if (this.businessType === 'บริษัทจำกัด') {
              this.nameUseInDocTh = 'บริษัท ' + this.companyNameFullTh + ' จำกัด'
            } else if (this.businessType === 'บริษัทมหาชนจำกัด') {
              this.nameUseInDocTh = 'บริษัท ' + this.companyNameFullTh + ' จำกัด (มหาชน)'
            } else {
              this.nameUseInDocTh = this.businessType + ' ' + this.companyNameFullTh
            }
            if (this.businessTypeEng === 'Company Limited') {
              this.nameUseInDocEng = this.companyNameFullEng + ' Co., Ltd.'
            } else if (this.businessTypeEng === 'Public Company Limited') {
              this.nameUseInDocEng = this.companyNameFullEng + ' Pub Co., Ltd.'
            } else if (this.businessTypeEng === 'Ordinary Partnership') {
              this.nameUseInDocEng = this.companyNameFullEng + ' Co.'
            } else if (this.businessTypeEng === 'Partnership Limited') {
              this.nameUseInDocEng = this.companyNameFullEng + ' Part., Ltd.'
            } else {
              this.nameUseInDocEng = this.companyNameFullEng + ' ' + this.businessTypeEng
            }
            this.statusChange = true
          }
        })
      } else {
        this.itemOrganization.forEach((element) => {
          if (element.nameEn === name) {
            this.businessType = element.name
            this.idbusinessTypeTh = element._id
            this.idbusinessTypeEng = element._id
            this.nameUseInDocTh = this.businessType + ' ' + this.companyNameFullTh
            this.nameUseInDocEng = this.companyNameFullEng + ' ' + this.businessTypeEng
            this.statusChange = true
          }
        })
      }
    },
    // อำเภอ
    Countycheck () {
      this.companyAddressDetail.district = ''
      this.listamphoe = []
      for (let i = 0; i < Datazibcode.length; i++) {
        const element = Datazibcode[i] // ประกาศ element มาเก็บค่าที่วนฟอของอำเภอ
        if (this.companyAddressDetail.province === element.province) { // เช็ดค่าถ้าจังหวัดที่เลือกมาตรงกับจังหวัดที่มีใน data ไหม ถ้าตรงให้เก็บค่าไว้ใน listamphoe
          this.listamphoe.push(element.amphoe)
        }
      }
      this.listdistrict = []
    },
    // ตำบล
    Districtcheck () {
      this.listdistrict = []
      for (let i = 0; i < Datazibcode.length; i++) {
        const element = Datazibcode[i]
        if (this.companyAddressDetail.district === element.amphoe) { // อำเภอที่เลือกตรงกับข้อมูลที่มีในตำบล
          this.listdistrict.push(element.district)
        }
      }
      this.companyAddressDetail.postCode = ''
    },
    // รหัสไปรษณีย์
    Zibcodecheck () {
      // เช็คจังหวัด อำเภอ ตำบล
      for (let i = 0; i < Datazibcode.length; i++) {
        const element = Datazibcode[i]
        if (this.companyAddressDetail.province === element.province && this.companyAddressDetail.district === element.amphoe && this.companyAddressDetail.subDistrict === element.district) {
          this.companyAddressDetail.postCode = element.zipcode
          // console.log(this.companyAddressDetail.postCode)
        }
      }
    },
    async getSelectbusinessType (type) {
      var nameSelect = ''
      if (type === 'กิจการ') {
        nameSelect = 'market'
      } else if (type === 'นิติบุคคล') {
        nameSelect = 'corporation'
      } else {
        nameSelect = 'organization'
      }
      await this.axios({
        method: 'get',
        url: `${this.api}/api/vMonk/selector/businessType?businessType=${nameSelect}`
      }).then(response => {
        if (nameSelect === 'market') {
          this.itemBusiness = []
          this.itemBusiness = response.data.selector
        } else if (nameSelect === 'corporation') {
          this.itemlegalEntity = []
          this.itemlegalEntity = response.data.selector
        } else {
          this.itemOrganization = []
          this.itemOrganization = response.data.selector
        }
      }).catch(e => {
        console.log(e)
      })
    },
    goBack () {
      this.$router.push('/managebusines')
    },
    cancel () {
      // this.files[0] = []
      // this.groupName = ''
      // this.filesCertificate[0] = []
      // this.filesPoa[0] = []
      // this.companyNameShortTh = ''
      // this.companyNameShortEng = ''
      // this.legalEntityTh = ''
      // this.companyNameFullTh = ''
      // this.nameUseInDocTh = ''
      // this.taxId = ''
      // this.email = ''
      // this.taxId = ''
      // this.region = ''
      // this.branchName = ''
      // this.branchCode = ''
      // this.branchName = ''
      // this.companyMobilNumber = ''
      // this.companyAddressDetail = ''
      // this.userIdList = []
      // this.userIdListTemporary = []
      // this.approver = []
      // this.temporaryer = []
      this.$router.go(-1)
    },
    // checkConfirmTaxDetailType (value) {
    //   if (value === 'ไม่มีข้อมูลผู้เสียภาษี') {
    //     if (this.taxId !== '') {
    //       this.dialogConfirmTaxDetail = true
    //     }
    //   }
    // },
    // เอกสารที่ต้องแนบ
    checkConfirmDocsDetailType (value) {
      if (value === 'ไม่มีหนังสือรับรอง') {
        if (this.filesCertificate.length > 0 || this.filesPoa.length > 0) {
          this.dialogConfirmDocsDetail = true
        }
      }
    },
    // end
    confirmDocsDetailType () {
      this.filesCertificate = []
      this.filesPoa = []
      this.checkboxpoa = false
      this.dialogConfirmDocsDetail = false
    },
    confirmTaxDetailType () {
      this.taxId = ''
      this.region = ''
      this.branchName = ''
      this.branchCode = ''
      this.companyMobilNumber = ''
      this.fax = ''
      this.dialogConfirmTaxDetail = false
    },
    async changeMode () {
      if (this.editMode === false) {
        this.editMode = true
        // await this.getCompanyDetail(this.reqBusinessId)
      } else {
        // this.editMode = false
        this.versionDate = this.versionDateOld
      }
    },
    onImgError (i) {
      // console.log('method: ', i)
      this.approver[i].failed_image = true
    },
    async getSelectCompany () {
      await this.axios({
        method: 'get',
        url: `${this.api}/api/vMonk/companys/selectGroupCompany`
      })
        .then(response => {
          // console.log('Get Edit List', response.data.result)
          var dataReverse = response.data.result
          this.itemCompany = dataReverse
          // console.log('revers/e', this.itemCompany)
          this.itemCompany.push({
            _id: '',
            groupCompanyNameEng: 'ไม่มี'
          })
          this.itemCompany = this.itemCompany.reverse()
        })
        .catch(e => {
          console.log(e)
        })
    },
    // async getUserDefault () {
    //   this.loading = true
    //   this.loadingUsers = true
    //   const obj = {
    //     name: this.$store.state.user.emailOneId
    //   }
    //   try {
    //     const res = await getUserByLogin(obj, this.tokenUser)
    //     console.log('ใหม่', res)
    //     if (res.success) {
    //       var filterValue = this.approver.filter(r => {
    //         console.log('ผู้ดูแล', r)
    //         if (
    //           r._id === res.selector[0]._id &&
    //           r.approverName === res.selector[0].titleTh + ' ' + res.selector[0].name
    //         ) {
    //           return r
    //         }
    //       })
    //       if (filterValue.length > 0) {
    //         swal('คำเตือน', 'คูณได้เพิ่มพนักงานคนนี้แล้ว', 'warning')
    //       } else {
    //         this.approver.push({
    //           approverNo: this.approver.length + 1,
    //           _id: res.selector[0]._id,
    //           employeeId: this.$store.state.user.employeeId,
    //           approverName: res.selector[0].titleTh + ' ' + res.selector[0].name,
    //           email: res.selector[0].emailOneId,
    //           tel: res.selector[0].tel,
    //           userImg: this.api + '/' + res.selector[0].userImg,
    //           companyId: this.$store.state.user.companyId,
    //           failed_image: false
    //         })
    //         this.userIdList.push({
    //           userId: res.selector[0]._id,
    //           companyId: this.$store.state.user.companyId
    //         })
    //       }
    //     }
    //   } catch (error) {
    //     console.log(error)
    //   } finally {
    //     this.loading = false
    //     this.loadingUsers = false
    //   }
    // },
    async downloadFile (value, nameFile) {
      await this.axios({
        method: 'get',
        responseType: 'blob',
        url: `${this.api}/api/vMonk/companys/getcompanyFileById/` + value
      })
        .then(response => {
          FileSaver.saveAs(new Blob([response.data]), nameFile)
        })
        .catch(e => {
          console.log(e)
        })
    },
    // qrcode
    // async getFormAuth () {
    //   console.log('click')
    //   // window.open(`${this.api}/api/vMonk/companys/qrCompany/download/` + '61d562fb991bb73ddc15ec85')
    //   console.log(this.$route.params.id)
    //   await this.axios({
    //     method: 'get',
    //     responseType: 'blob',
    //     url:
    //       `${this.api}/api/vMonk/companys/qrCompany/download/` +
    //       this.$route.params.id
    //     // url: `${this.api}/api/vMonk/companys/qrCompany/download/61d562fb991bb73ddc15ec85`
    //   })
    //     .then(response => {
    //       FileSaver.saveAs(new Blob([response.data]), 'qr-code.png')
    //     })
    //     .catch(e => {
    //       console.log(e)
    //     })
    // },
    async getFormPoa () {
      await this.axios({
        method: 'get',
        responseType: 'blob',
        url: `${this.api}/api/vMonk/companys/downloadSPOA`
      })
        .then(response => {
          FileSaver.saveAs(
            new Blob([response.data]),
            'หนังสือมอบอำนาจช่วง.docx'
          )
        })
        .catch(e => {
          console.log(e)
        })
    },
    async chageVersion (value) {
      this.versionDateOld = value
      if (this.editMode === true) {
        this.dialogChangeVer = true
      } else {
        await this.getDetailVersion(this.versionDateOld)
      }
    },
    async cancelVersion () {
      this.dialogChangeVer = false
      this.versionDate = this.versionDateOld
      await this.getDetailVersion(this.versionDateOld)
    },
    async getDetailVersion (id) {
      const tempApprover = []
      this.approver = []
      this.userIdList = []
      this.dialogChangeVer = false
      this.loading = true
      var itemVersionDetail = this.itemVersion.filter(e => e._id === id)
      if (itemVersionDetail[0].businessModelType === 'market') {
        this.businessModelType = 'กิจการ'
      } else if (itemVersionDetail[0].businessModelType === 'corporation') {
        this.businessModelType = 'นิติบุคคล'
      } else {
        this.businessModelType = 'องค์กร'
      }
      this.businessType = itemVersionDetail[0].businessType
      this.taxDetailType = itemVersionDetail[0].taxDetail === false ? 'ไม่มีข้อมูลผู้เสียภาษี' : 'มีข้อมูลผู้เสียภาษี'
      this.docsDetailType = itemVersionDetail[0].docDetail === false ? 'ไม่มีหนังสือรับรอง' : 'มีหนังสือรับรอง'
      this.companyNameShortTh = itemVersionDetail[0].companyShortNameTh === '' ? '-' : itemVersionDetail[0].companyShortNameTh
      this.companyNameShortEng = itemVersionDetail[0].companyShortNameEng
      this.legalEntityTh = itemVersionDetail[0].legalEntityTh
      this.companyNameFullTh = itemVersionDetail[0].companyFullNameTh
      this.nameUseInDocTh = itemVersionDetail[0].nameUseInDocTh
      this.legalEntityEng = itemVersionDetail[0].legalEntityEng
      this.companyNameFullEng = itemVersionDetail[0].companyFullNameEng
      this.nameUseInDocEng = itemVersionDetail[0].nameUseInDocEng
      this.taxId = itemVersionDetail[0].taxId
      this.email = itemVersionDetail[0].email
      // this.taxemail = itemVersionDetail[0].taxemail
      this.region = itemVersionDetail[0].region
      this.branchName = itemVersionDetail[0].branchName
      this.branchCode = itemVersionDetail[0].branchCode
      this.companyTelNo = itemVersionDetail[0].companyTelNo
      // this.taxTelNo = itemVersionDetail[0].taxTelNo
      this.companyMobilNumber = itemVersionDetail[0].companyMobilNumber
      this.fax = itemVersionDetail[0].fax
      this.companyAddressDetail.codeAddress =
        itemVersionDetail[0].companyAddressDetail.codeAddress
      this.companyAddressDetail.address =
        itemVersionDetail[0].companyAddressDetail.address
      this.companyAddressDetail.roomNo =
        itemVersionDetail[0].companyAddressDetail.roomNo
      this.companyAddressDetail.floorNo =
        itemVersionDetail[0].companyAddressDetail.floorNo
      this.companyAddressDetail.buildingName =
        itemVersionDetail[0].companyAddressDetail.buildingName
      this.companyAddressDetail.villageName =
        itemVersionDetail[0].companyAddressDetail.villageName
      this.companyAddressDetail.villageNo =
        itemVersionDetail[0].companyAddressDetail.villageNo
      this.companyAddressDetail.alley =
        itemVersionDetail[0].companyAddressDetail.alley
      this.companyAddressDetail.dispart =
        itemVersionDetail[0].companyAddressDetail.dispart
      this.companyAddressDetail.road =
        itemVersionDetail[0].companyAddressDetail.road
      this.companyAddressDetail.province =
        itemVersionDetail[0].companyAddressDetail.province
      this.companyAddressDetail.district =
        itemVersionDetail[0].companyAddressDetail.district
      this.companyAddressDetail.subDistrict =
        itemVersionDetail[0].companyAddressDetail.subDistrict
      this.companyAddressDetail.postCode =
        itemVersionDetail[0].companyAddressDetail.postCode
      this.filesCertificateId = itemVersionDetail[0].companyCertificate
      this.filesCertificateName = itemVersionDetail[0].companyCertificateName
      this.poaId = itemVersionDetail[0].powerOfAttorney
      this.poaName = itemVersionDetail[0].powerOfAttorneyName
      this.checkboxpoa = itemVersionDetail[0].checkboxpoa
      this.versionDate = this.versionDateOld
      // ไม่ได้ใช้
      // this.progressValue = itemVersionDetail[0].reliability
      // this.progressColor =
      //   this.progressValue <= 30
      //     ? '#F37959'
      //     : this.progressValue > 30 && this.progressValue <= 61
      //       ? '#F2BE47'
      //       : this.progressValue > 61 && this.progressValue <= 79
      //         ? '#3D5D85'
      //         : '#6FB540'
      // this.imageUrl = `${this.api}/api/vMonk/companys/getcompanyFileById/` + itemVersionDetail[0].companyImage
      var imagesUrlCompany = itemVersionDetail[0].companyImage
      this.axios({
        method: 'get',
        responseType: 'data',
        url:
          `${this.api}/api/vMonk/companys/getcompanyFileById/` +
          imagesUrlCompany
      })
        .then(response => {
          // console.log('test value', imagesUrlCompany)
          this.imageUrl = this.imageUrl =
            `${this.api}/api/vMonk/companys/getcompanyFileById/` +
            imagesUrlCompany
        })
        .catch(e => {
          // console.log('test value', imagesUrlCompany)
          this.imageUrl =
            `${this.api}/api/vMonk/companys/getcompanyFileById/` +
            imagesUrlCompany
          console.log(e)
        })
      if (itemVersionDetail[0].userData !== '') {
        itemVersionDetail[0].userData.map((el, index) => {
          // el.companyImage = `${this.api}/api/vMonk/companys/getcompanyFileById/` + el.companyImage
          tempApprover.push({
            approverNo: this.approver.length + 1,
            approverName: el.titleTh + el.firstNameTh + ' ' + el.lastNameTh,
            email: el.emailOneId,
            tel: el.tel,
            failed_image: false,
            ...el
          })
          this.userIdList.push({
            userId: el.employeeId,
            companyId: el.companyId
          })
          this.approver = tempApprover
        })
      } else {
        this.approver = itemVersionDetail[0].companyLeader
      }
      var pathFileName = 'uploads/companyFile/' + this.companyNameFullEng + '/'
      var substringsCertificate = itemVersionDetail[0].companyCertificate.split(
        pathFileName,
        2
      )
      var substringsPoa = itemVersionDetail[0].powerOfAttorney.split(
        pathFileName,
        2
      )
      this.filesPoa.push({
        name: substringsPoa[1]
      })
      this.filesCertificate.push({
        name: substringsCertificate[1]
      })
      setTimeout(() => {
        this.editMode = false
        this.loading = false
      }, 500)
      // this.dialogEdit = value
    },
    async getCompanyDetail (id) {
      this.loading = true
      await this.axios({
        // อันเดิม
        // method: 'post',
        // url: `${this.api}/api/vMonk/companys/getBusinessById`,
        // data: {
        //   businessId: id
        // }
        // อันใหม่
        method: 'GET',
        url: `${this.api}/api/vMonk/organization/` + id,
        headers: {
          authorization: this.$store.state.token
        }
      })
        .then(response => {
          this.approver = []
          const tempApprover = []
          this.userIdList = []
          this.imageUrl = ''
          this.itemDetail = response.data.result
          this.itemDetailOld = response.data.result
          // this.itemDetailOld = JSON.stringify(response.data.result)
          // this.itemCompany = response.data.result.companyName
          if (response.data.result.groupCompanyId === null) {
            this.groupName = null
          } else {
            this.groupName = response.data.result.groupCompanyId
          }
          if (response.data.result.businessModelType === 'corporation') {
            this.businessModelType = 'นิติบุคคล'
          } else if (response.data.result.businessModelType === 'market') {
            this.businessModelType = 'กิจการ'
          } else {
            this.businessModelType = 'องค์กร'
          }
          this.TypebusinessRegister = response.data.result.registerType === 'registerFull' ? 'ลงทะเบียนธุรกิจฉบับเต็ม' : 'ลงทะเบียนธุรกิจฉบับย่อ' // รูปแบบการลงทะเบียน(รอข้อมูล)
          this.businessType = response.data.result.businessType // ประเภทกิจการ,ประเภทนิติบุคคล,ประเภทองค์กร (th)
          this.businessTypeEng = response.data.result.businessTypeEn // businessTypeEng ประเภทกิจการ,ประเภทนิติบุคคล,ประเภทองค์กร (eng)
          this.taxDetailType = response.data.result.taxDetail === false ? 'ไม่มีข้อมูลผู้เสียภาษี' : 'มีข้อมูลผู้เสียภาษี' // รูปแบบการเสียภาษี
          this.docsDetailType = response.data.result.docDetail === false ? 'ไม่มีหนังสือรับรอง' : 'มีหนังสือรับรอง' // รูปแบบหนังสือรับรอง
          this.companyNameShortEng = response.data.result.companyShortNameEng === '' ? '-' : response.data.result.companyShortNameEng // ชื่อย่อภาษาอังกฤษ
          this.companyNameShortTh = response.data.result.companyShortNameTh === '' ? '-' : response.data.result.companyShortNameTh
          // this.legalEntityTh = response.data.result.legalEntityTh
          this.companyNameFullTh = response.data.result.companyFullNameTh // ชื่อเต็มภาษาไทย
          this.nameUseInDocTh = response.data.result.nameUseInDocTh // ชื่อแสดงบนเอกสารไทย
          // this.legalEntityEng = response.data.result.legalEntityEng
          this.companyNameFullEng = response.data.result.companyFullNameEng // ชื่อเต็มภาษาอังกฤษ
          this.nameUseInDocEng = response.data.result.nameUseInDocEng // ชื่อแสดงบนเอกสารอังกฤษ
          this.taxId = response.data.result.taxId // เลขที่ผู้เสียภาษีอากร
          this.email = response.data.result.email // อีเมลในส่วนของรายละเอียด
          this.region = response.data.result.region // ภูมิภาค
          this.branchName = response.data.result.branchName // ชื่อสาขา
          this.branchCode = response.data.result.branchCode // รหัสสาขา
          this.companyTelNo = response.data.result.companyTelNo // เบอร์โทรศัพท์รายละเอียด
          this.companyMobilNumber = response.data.result.companyMobilNumber // เบอร์มือถือ
          this.fax = response.data.result.fax // โทรสาร
          this.companyAddressDetail.codeAddress =
            response.data.result.companyAddressDetail.codeAddress // รหัสประจำที่อยู่
          this.companyAddressDetail.address =
            response.data.result.companyAddressDetail.address // ที่อยู่
          this.companyAddressDetail.roomNo =
            response.data.result.companyAddressDetail.roomNo // เลขที่ห้อง
          this.companyAddressDetail.floorNo =
            response.data.result.companyAddressDetail.floorNo
          this.companyAddressDetail.buildingName =
            response.data.result.companyAddressDetail.buildingName
          this.companyAddressDetail.villageName =
            response.data.result.companyAddressDetail.villageName // หมู่บ้าน
          this.companyAddressDetail.villageNo =
            response.data.result.companyAddressDetail.villageNo // หมู่ที่
          this.companyAddressDetail.alley =
            response.data.result.companyAddressDetail.alley // ตรอก/ซอย
          this.companyAddressDetail.dispart =
            response.data.result.companyAddressDetail.dispart // แยก
          this.companyAddressDetail.road =
            response.data.result.companyAddressDetail.road // ถนน
          this.companyAddressDetail.province =
            response.data.result.companyAddressDetail.province // จังหวัด
          this.companyAddressDetail.district =
            response.data.result.companyAddressDetail.district // อำเภอ/เขต
          this.companyAddressDetail.subDistrict =
            response.data.result.companyAddressDetail.subDistrict // ตำบล/แขวง
          this.companyAddressDetail.postCode =
            response.data.result.companyAddressDetail.postCode // รหัสไปรษณีย์
          this.filesCertificateId = response.data.result.companyCertificate
          this.filesCertificateName =
            response.data.result.companyCertificateName // ชื่อไฟล์รับรอง
          this.poaId = response.data.result.powerOfAttorney // id หนังสือมอบอำนาจ()
          this.poaName = response.data.result.powerOfAttorneyName // ชื่อหนังสือมอบอำนาจ
          this.checkboxpoa = response.data.result.checkboxpoa // ผู้รักษาการแทน(รอข้อมูล)
          // this.password = response.data.result.password // รหัสผ่านเอกสาร
          // this.password = response.data.result.documentId // รหัสเอกสาร
          // ไม่ได้ใช้แล้วเพราะไม่ได้ดึงมาแสดง
          // if (response.data.result.version.length > 0) {
          //   this.status = response.data.result.version[0].status
          // }
          // this.progressValue = response.data.result.reliability
          // this.progressColor =
          //   this.progressValue <= 30
          //     ? '#F37959'
          //     : this.progressValue > 30 && this.progressValue <= 61
          //       ? '#F2BE47'
          //       : this.progressValue > 61 && this.progressValue <= 79
          //         ? '#3D5D85'
          //         : '#6FB540'
          // สิ้นสุด

          // รอหลังบ้านส่ง key มาให้ใหม่แล้วค่อยเปิดโค้ดกลับมา
          this.itemVersion = []
          response.data.result.version.map((el, index) => {
            this.itemVersion.push({
              no: el.versionNo,
              detail:
                'เวอร์ชั่นที่ ' +
                el.versionNo +
                ' - ' +
                this.initDate(el.updateAt),
              ...el
            })
          })
          this.versionDate =
            response.data.result.version.length !== 0
              ? response.data.result.version[0]._id
              : []
          this.versionDateOld = this.versionDate
          // สิ้นสุด
          var imagesUrlCompany = response.data.result.companyImage
          if (imagesUrlCompany !== '') {
            this.axios({
              method: 'get',
              responseType: 'data',
              url:
                `${this.api}/api/vMonk/companys/getcompanyFileById/` +
                imagesUrlCompany
            })
              .then(response => {
                this.imageUrl = this.imageUrl =
                  `${this.api}/api/vMonk/companys/getcompanyFileById/` +
                  imagesUrlCompany
                // this.imageQrcode = this.api + '/api/vMonk/companys/qrCompany/' + imagesUrlCompany
                // this.imageQrcode = `${this.api}/api/vMonk/companys/qrCompany/` + '61d562fb991bb73ddc15ec85'
                // console.log('img', this.imageUrl)
              })
              .catch(e => {
                this.imageUrl = ''
                console.log(e)
              })
          }
          // qrcode
          // if (id) {
          //   this.axios({
          //     method: 'get',
          //     responseType: 'data',
          //     url: `${this.api}/api/vMonk/companys/qrCompany/` + id
          //   })
          //     .then(response => {
          //       this.imageQrcode =
          //         this.api + '/api/vMonk/companys/qrCompany/' + id
          //       // this.imageQrcode = `${this.api}/api/vMonk/companys/qrCompany/` + '61d562fb991bb73ddc15ec85'
          //       // console.log('img', this.imageUrl)
          //     })
          //     .catch(e => {
          //       this.imageQrcode = ''
          //       console.log(e)
          //     })
          // }
          response.data.result.companyLeader.map((el, index) => {
            tempApprover.push({
              approverNo: this.approver.length + 1,
              approverName: el.titleTh + el.firstNameTh + ' ' + el.lastNameTh,
              email: el.emailOneId,
              tel: el.tel,
              failed_image: false,
              ...el
            })
            this.userIdList.push({
              userId: el._id,
              companyId: el.companyId
            })
            this.approver = tempApprover
          })
          // var pathFileName =
          //   'uploads/companyFile/' + this.companyNameFullEng + '/'
          var substringsCertificate = response.data.result.companyCertificateName
          var substringsPoa = response.data.result.powerOfAttorneyName
          if (substringsPoa !== '') {
            this.filesPoa.push({
              name: substringsPoa
            })
          } else {
            this.filesPoa = []
          }
          if (substringsCertificate !== '') {
            this.filesCertificate.push({
              name: substringsCertificate
            })
          } else {
            this.filesCertificate = []
          }
          // if (this.editMode === true) {
          //   if (this.versionDateOld !== '') {
          //     this.getDetailVersion(this.versionDateOld)
          //   }
          // this.getSelectbusinessType(this.businessModelType)
          // }
          // this.menuQrcode = true
          this.loading = false
          // this.dialogEdit = value
        })
        .catch(e => {
          swal('คำเตือน', 'คุณไม่มีสิทธิ์เข้าดูเอกสารนี้', 'warning', {
            button: false,
            timer: 2000
          })
          setTimeout(() => {
            this.goBack()
          }, 2000)
          console.log(e.message)
          this.loading = false
        })
    },
    openDialogAddAprover (action, item, index, type) {
      // console.log('add')
      EventBus.$emit('openDialogAddAprover', true, item, action, index, type)
    },
    add (value, index, action, type) {
      var today = new Date()
      var date =
        today.getDate() +
        '-' +
        (today.getMonth() + 1) +
        '-' +
        today.getFullYear()
      var filterValue = this.approver.filter(r => {
        // if (r.position === value.position && r.employeeId === value.employeeId) {
        if (r._id === value.id && r.email === value.email) {
          return r
        }
      })
      var filterValueTemporary = this.temporaryer.filter(r => {
        // if (
        //   r.position === value.position &&
        //   r.employeeId === value.employeeId
        // ) {
        if (r._id === value.id && r.email === value.email) {
          return r
        }
      })
      if (type === 'approver') {
        if (action === 'add') {
          if (filterValue.length > 0) {
            swal('คำเตือน', 'คุณได้เพิ่มพนักงานคนนี้แล้ว', 'warning')
          } else {
            this.approver.push({
              approverNo: this.approver.length + 1,
              _id: value.id,
              // employeeId: value.employeeId,
              approverName: value.name,
              // position: value.position,
              email: value.email,
              tel: value.tel,
              userImg: value.userImg,
              // approveType: value.approveType,
              failed_image: false
            })
            this.userIdList.push({
              userId: value.id,
              companyId: ''
              // companyId: value.companyId
            })
          }
        } else if (action === 'edit') {
          if (filterValue.length > 0) {
            swal('คำเตือน', 'คุณได้เพิ่มพนักงานคนนี้แล้ว', 'warning')
          } else {
            this.approver[index].approverNo = index + 1
            this.approver[index]._id = value.id
            // this.approver[index].employeeId = value.employeeId
            this.approver[index].approverName = value.name
            // this.approver[index].position = value.position
            this.approver[index].email = value.email
            // this.approver[index].approveType = value.approveType
            this.approver[index].userImg = value.userImg
            this.approver[index].tel = value.tel
            this.approver[index].failed_image = value.failed_image || false

            this.userIdList[index].userId = value.id
            this.userIdList[index].companyId = ''
            // this.userIdList[index].companyId = value.companyId
          }
        }
      } else if (type === 'temporaryer') {
        if (action === 'add') {
          if (filterValueTemporary.length > 0) {
            swal('คำเตือน', 'คุณได้เพิ่มพนักงานคนนี้แล้ว', 'warning')
          } else {
            this.temporaryer.push({
              approverNo: this.approver.length + 1,
              _id: value.id,
              employeeId: value.employeeId,
              approverName: value.name,
              position: value.position,
              email: value.email,
              tel: value.tel,
              userImg: value.userImg,
              approveType: value.approveType,
              failed_image: false
            })
            this.userIdListTemporary.push({
              userId: value.id,
              temporaryDate: date
            })
          }
        } else if (action === 'edit') {
          if (filterValueTemporary.length > 0) {
            swal('คำเตือน', 'คุณได้เพิ่มพนักงานคนนี้แล้ว', 'warning')
          } else {
            this.temporaryer[index].approverNo = index + 1
            this.temporaryer[index]._id = value.id
            this.temporaryer[index].employeeId = value.employeeId
            this.temporaryer[index].approverName = value.name
            this.temporaryer[index].position = value.position
            this.temporaryer[index].email = value.email
            this.temporaryer[index].approveType = value.approveType
            this.temporaryer[index].userImg = value.userImg
            this.temporaryer[index].failed_image = value.failed_image || false
          }
        }
      }
    },
    checkRemove (item, type) {
      this.itemConfirmDelete = []
      this.titleDialog = type
      this.itemConfirmDelete = item
      this.dialogDeleteApprover = true
    },
    removeApprover (item, type) {
      // console.log('removeApprover', this.approver.indexOf(item))
      if (type === 'approver') {
        this.approver.splice(this.approver.indexOf(item), 1)
        this.userIdList.splice(this.userIdList.indexOf(item), 1)
        this.itemConfirmDelete = []
        this.itemIndex = 0
        this.dialogDeleteApprover = false
      } else if (type === 'temporaryer') {
        this.temporaryer.splice(this.temporaryer.indexOf(item), 1)
        this.itemConfirmDelete = []
        this.itemIndex = 0
        this.dialogDeleteApprover = false
      }
    },
    async submitDataCreate () {
      // var valueNew = true
      // var valueOld = false
      var taxTrue = true
      var taxFalse = false
      var docsTrue = true
      var doscFalse = false
      // var newIdType = '' // เก็บค่า id ประเภทส่งกลับไปบันทึก
      var valuefiles = ''
      var valueCertificate = ''
      var valuepowerOfAttorney = ''
      var engbusinessModelType = ''
      this.userDataStore = this.$store.state.user
      if (this.businessModelType === 'กิจการ') {
        engbusinessModelType = 'market'
        this.itemBusiness.forEach(element => {
          if (this.businessType === element.name) {
            // newIdType = element._id
            this.idbusinessTypeEng = element._id
            this.idbusinessTypeTh = element._id
          }
        })
      } else if (this.businessModelType === 'นิติบุคคล') {
        engbusinessModelType = 'corporation'
        this.itemlegalEntity.forEach(element => {
          if (this.businessType === element.name) {
            // newIdType = element._id
            this.idbusinessTypeEng = element._id
            this.idbusinessTypeTh = element._id
          }
        })
      } else {
        engbusinessModelType = 'organization'
        this.itemOrganization.forEach(element => {
          if (this.businessType === element.name) {
            // newIdType = element._id
            this.idbusinessTypeEng = element._id
            this.idbusinessTypeTh = element._id
          }
        })
      }
      if (this.businessType === 'อื่นๆโปรดระบุ') {
        // newIdType = this.otherTypeNamesTh
        this.idbusinessTypeEng = this.otherTypeNamesEng
        this.idbusinessTypeTh = this.otherTypeNamesTh
      }
      if (this.TypebusinessRegister === 'ลงทะเบียนธุรกิจฉบับย่อ' && this.businessModelType === 'กิจการ') {
        this.taxId = ''
        this.region = ''
        this.branchName = ''
        this.branchCode = ''
        this.companyMobilNumber = ''
        this.fax = ''
        valueCertificate = ''
        valuepowerOfAttorney = ''
        this.checkboxpoa = false
      } else if (this.TypebusinessRegister === 'ลงทะเบียนธุรกิจฉบับย่อ' && (this.businessModelType === 'นิติบุคคล' || this.businessModelType === 'องค์กร')) {
        this.taxId = ''
        this.region = ''
        this.branchName = ''
        this.branchCode = ''
        this.companyMobilNumber = ''
        this.fax = ''
        this.email = ''
        this.companyTelNo = ''
        valueCertificate = ''
        valuepowerOfAttorney = ''
        this.checkboxpoa = false
      } else if (this.TypebusinessRegister === 'ลงทะเบียนธุรกิจฉบับเต็ม' && this.taxDetailType === 'ไม่มีข้อมูลผู้เสียภาษี' && this.businessModelType === 'กิจการ') {
        this.taxId = ''
        this.region = ''
        this.branchName = ''
        this.branchCode = ''
        this.companyMobilNumber = ''
        this.fax = ''
      } else if (this.TypebusinessRegister === 'ลงทะเบียนธุรกิจฉบับเต็ม' && this.taxDetailType === 'ไม่มีข้อมูลผู้เสียภาษี' && (this.businessModelType === 'องค์กร' || this.businessModelType === 'นิติบุคคล')) {
        this.taxId = ''
        this.region = ''
        this.branchName = ''
        this.branchCode = ''
        this.companyMobilNumber = ''
        this.fax = ''
        this.email = ''
        this.companyTelNo = ''
      }
      if (this.files[0] === undefined) {
        valuefiles = ''
      } else {
        valuefiles = this.files[0]
      }
      if (this.filesCertificate === []) {
        valueCertificate = ''
      } else {
        valueCertificate = this.filesCertificate[0]
      }
      if (this.filesPoa === []) {
        valuepowerOfAttorney = ''
      } else {
        valuepowerOfAttorney = this.filesPoa[0]
      }
      var formData = new FormData()
      formData.append('role', this.approveRole)
      formData.append('companyId', this.reqBusinessId)
      formData.append('image', valuefiles) // รูปภาพเดิม
      // formData.append('imageUpdate', this.files[0] === undefined ? valueOld : valueNew) // มีรูปภาพเปลี่ยนแปลงใหม่
      formData.append('certificate', valueCertificate) // หนังสือรับรองเดิม
      // formData.append('certificateUpdate', this.filesCertificate[0].name === '' ? valueOld : valueNew) // มีหนังสือรับรองเปลี่ยนแปลงใหม่
      formData.append('powerOfAttorney', valuepowerOfAttorney) // หนังสือมอบอำนาจ
      formData.append('statusPowerOfAttorney', this.checkboxpoa) // status บอกว่ามีหนังสือมอบอำนาจไหม T/F
      // formData.append('powerOfAttorneyUpdate', this.filesPoa[0].name === '' ? valueOld : valueNew) // มีหนังสือมอบอำนาจเปลี่ยนแปลงใหม่
      formData.append('businessModelType', engbusinessModelType) // ประเภทธุรกิจที่เลือก
      formData.append('registerType', this.TypebusinessRegister === 'ลงทะเบียนธุรกิจฉบับเต็ม' ? 'registerFull' : 'registerShort') // เพิ่มมาใหม่ส่วนของรูปแบบลงทะเบียนแบบเต็มกับย่อ
      formData.append('businessType', this.idbusinessTypeTh) // businessTypeTh ประเภทกิจการ,ประเภทองค์กร,ประเภทนิติบุคคล (th)
      formData.append('businessTypeEn', this.idbusinessTypeEng) // ประเภทกิจการ,ประเภทองค์กร,ประเภทนิติบุคคล (eng)
      // formData.append('legalEntityEng', this.legalEntityEng) // ประเภทนิติบุคคลอังกฤษ
      formData.append('companyFullNameEng', this.companyNameFullEng) // ชื่อเต็มภาษาไทย
      formData.append('companyFullNameTh', this.companyNameFullTh) // ชื่อเต็มภาษาอังกฤษ
      formData.append('companyShortNameTh', this.companyNameShortTh) // ชื่อย่อภาษาไทย
      formData.append('companyShortNameEng', this.companyNameShortEng) // ชื่อย่อภาษาอังกฤษ
      // formData.append('groupCompanyId', this.groupName)
      formData.append('nameUseInDocTh', this.nameUseInDocTh) // ชื่อแสดงบนเอกสารภาษาไทย
      formData.append('nameUseInDocEng', this.nameUseInDocEng) // ชื่อแสดงบนเอกสารภาษาอังกฤษ
      formData.append('taxDetail', this.taxDetailType === 'ไม่มีข้อมูลผู้เสียภาษี' ? taxFalse : taxTrue) // ข้อมูลผู้เสียภาษี(ส่งค่าเป็น t/f)
      formData.append('docsDetail', this.docsDetailType === 'ไม่มีหนังสือรับรอง' ? doscFalse : docsTrue) // เอกสารที่ต้องแนบ (ส่งค่าเป็น t/f)
      formData.append('taxId', this.taxId) // เลขที่ผู้เสียภาษีอากร
      formData.append('email', this.email) // อีเมล
      // formData.append('taxemail', this.taxemail) // อีเมลภาษี
      formData.append('branchName', this.branchName) // ชื่อสาขา
      formData.append('branchCode', this.branchCode) // รหัสสาขา
      formData.append('companyTelNo', this.companyTelNo) // เบอร์โทรศัพท์ในส่วนของรายละเอียด
      // formData.append('taxTelNo', this.taxTelNo) // เบอร์โทรศัพท์ในส่วนของภาษี
      formData.append('region', this.region) // ภูมิภาค
      formData.append('companyMobilNumber', this.companyMobilNumber) // เบอร์มือถือ
      formData.append('fax', this.fax) // โทรสาร
      formData.append('companyAddressDetail', JSON.stringify(this.companyAddressDetail)) // ข้อมูลที่อยู่
      formData.append('companyLeader', JSON.stringify(this.userIdList))
      formData.append('password', this.password)
      formData.append('documentId', this.documentId)
      // formData.append('temporaryLeaderCompany', '')
      // formData.append('temporaryLeaderCompany', JSON.stringify(this.userIdListTemporary))
      const obj = formData
      if (
        this.taxDetailType === 'มีข้อมูลผู้เสียภาษี' &&
        this.taxId === '' &&
          this.region === '' &&
          this.branchName === '' &&
          this.branchCode === '' &&
          this.companyMobilNumber === '' &&
          this.fax === ''
      ) {
        this.dialogConfirmSubmit = false
        swal('คำเตือน', 'กรุณากรอกข้อมูลผู้เสียภาษีให้ครบ', 'warning')
      } else {
        try {
          // const res = await updateBusiness(obj, this.$store.state.token) // เก่า
          const res = await updateBusinessNew(this.reqBusinessId, obj, this.$store.state.token) // ใหม่
          if (res.success) {
            this.text = 'คุณได้ทำการแก้ไขธุรกิจเรียบร้อยแล้ว'
            this.snackbarColor = 'success'
            this.snackbar = true
            this.dialogConfirmSubmit = false
            setTimeout(() => {
              this.imageUrl = ''
              // this.getCompanyDetail(this.reqBusinessId)
              this.$router.push('/managebusines')
              this.editMode = false
            }, 500)
            if (this.approveRole === 'User') {
              this.$router.push('/manageapprovebusiness')
            }
            // this.goBack()
          } else {
            this.dialogConfirmSubmit = false
            // swal('ผิดพลาด', res.data.msg, 'error')
            if (res.data.message === 'this taxId and branchCode has exist') {
              swal('ผิดพลาด', 'เนื่องจากเลขที่ผู้เสียภาษีอากรนี้ มีรหัสสาขานี้อยู่แล้ว', 'error', {
                button: false,
                timer: 3000
              })
            } else {
              swal('ผิดพลาด', 'เนื่องจากชื่อบริษัทซ้ำกับที่มีในระบบ กรุณาลองใหม่อีกครั้ง', 'error', {
                button: false,
                timer: 3000
              })
            }
            // this.loading = false
          }
        } catch (error) {
          console.log(error)
          this.dialogConfirmSubmit = false
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
          // this.loading = false
        } finally {
          // this.loadingEmployeeData = false
        }
      }
    },
    addFiles (type) {
      if (type === 'certificate') {
        this.$refs.PickfilesCertificate.click()
      } else if (type === 'poa') {
        this.$refs.PickfilesPoa.click()
      }
    },
    onFileSelected (type) {
      if (type === 'certificate') {
        // this.filesCertificate = []
        var uploadedFilesCertificate = this.$refs.PickfilesCertificate.files
        for (let i = 0; i < uploadedFilesCertificate.length; i++) {
          var dotindexCertificate = uploadedFilesCertificate[
            i
          ].name.lastIndexOf('.')
          var FileExtension = uploadedFilesCertificate[i].name
            .substr(dotindexCertificate + 1)
            .toLowerCase()

          if (FileExtension === 'pdf') {
            this.filesCertificate = []
            this.loadingFile = true
            this.filesCertificate.push(uploadedFilesCertificate[i])
            setTimeout(() => {
              this.loadingFile = false
            }, 2000)
          } else {
            swal(
              'คำเตือน',
              `ไม่รองรับไฟล์${uploadedFilesCertificate[i].name.substr(-4)}`,
              'warning'
            )
          }
        }
      } else if (type === 'poa') {
        // this.filesPoa = []
        var uploadedFilesPoa = this.$refs.PickfilesPoa.files
        for (let i = 0; i < uploadedFilesPoa.length; i++) {
          var dotindexPoa = uploadedFilesPoa[i].name.lastIndexOf('.')
          var FileExtensionPoa = uploadedFilesPoa[i].name
            .substr(dotindexPoa + 1)
            .toLowerCase()

          if (FileExtensionPoa === 'pdf') {
            this.filesPoa = []
            this.loadingFilePoa = true
            this.filesPoa.push(uploadedFilesPoa[i])
            setTimeout(() => {
              this.loadingFilePoa = false
            }, 2000)
          } else {
            swal(
              'คำเตือน',
              `ไม่รองรับไฟล์${uploadedFilesPoa[i].name.substr(-4)}`,
              'warning'
            )
          }
        }
      }
    },
    removeFile (key, type) {
      if (type === 'certificate') {
        this.filesCertificate.splice(key, 1)
        const input = this.$refs.PickfilesCertificate
        input.type = 'text'
        input.type = 'file'
        this.password = ''
        this.documentId = ''
      } else if (type === 'poa') {
        this.filesPoa.splice(key, 1)
        const input = this.$refs.PickfilesPoa
        input.type = 'text'
        input.type = 'file'
      }
      // // console.log('remove key', key)
      // console.log('FILE ', this.files)
    },
    async deleteBusiness () {
      const obj = {
        businessId: this.reqBusinessId
      }
      try {
        const res = await deleteBusinessById(obj, this.$store.state.token)
        if (res.success) {
          swal('สำเร็จ', 'คุณได้ทำการลบข้อมูล เรียบร้อยแล้ว', 'success', {
            button: false,
            timer: 2000
          })
          this.dialogConfirmDel = false
          this.goBack()
        } else {
          this.dialogConfirmDel = false
          swal('ผิดพลาด', 'ไม่สาารถลบข้อมูลได้ กรุณาลองใหม่', 'error', {
            button: false,
            timer: 2000
          })
        }
      } catch (error) {
        console.log(error)
      }
      // this.text = 'คุณได้ทำการลบข้อมูลผู้อนุมัติเรียบร้อยแล้ว'
      // this.snackbar = true
    },
    async updateStatusApprove (type) {
      await axios({
        url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/companys/updateStatusReqBusinessByToken`,
        method: 'POST',
        headers: {
          authorization: this.$store.state.token
        },
        data: {
          // approveList: confirmList
          reqBusinessId: this.reqBusinessId,
          status:
            type === 'อนุมัติ'
              ? 'approve'
              : type === 'ไม่อนุมัติ'
                ? 'reject'
                : 'cancel',
          role: this.$store.state.user.role[1].permission,
          comment: this.comment
        }
      })
        .then(response => {
          if (response.data.success === true) {
            swal('สำเร็จ', 'ทำรายการเรียบร้อย', 'success', {
              button: false,
              timer: 2000
            })
            // this.dialog = false
            // this.snackbar = true
            this.page = 1
            this.dialogApproverCompany = false
            this.$router.push('/managebusiness')
            // self.searchFilterData(self.filterData)
          } else {
            swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
              button: false,
              timer: 2000
            })
          }
        })
        .catch(function (thrown) {
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
        })
    },
    ChooseBanner () {
      this.$refs.Pickfiles.click()
    },
    onBannerSelected () {
      this.files = []
      var uploadedImage = this.$refs.Pickfiles.files
      var dotindex = uploadedImage[0].name.lastIndexOf('.')
      var FileExtension = uploadedImage[0].name
        .substr(dotindex + 1)
        .toLowerCase()
      if (
        FileExtension === 'jpg' ||
        FileExtension === 'png' ||
        FileExtension === 'JPG' ||
        FileExtension === 'PNG'
      ) {
        if (!uploadedImage[0]) return
        const reader = new FileReader()
        reader.readAsDataURL(uploadedImage[0])
        reader.onload = evt => {
          var img = new Image()
          this.files.push(uploadedImage[0])
          // console.log(this.files[0])
          const fr = new FileReader()
          fr.readAsDataURL(this.files[0])
          fr.addEventListener('load', () => {
            this.nameimg = this.files[0].name
            this.imageUrl = fr.result
          })
          img.src = evt.target.result
        }
        // reader.onerror = evt => {
        //   console.error(evt)
        // }
      } else {
        swal(
          'คำเตือน',
          `ไม่รองรับไฟล์${uploadedImage[0].name.substr(-4)}`,
          'warning'
        )
      }
    },
    initDate (date) {
      return moment(date).format('DD/MM/YYYY HH:mm น.')
    },
    copyData () {
      // this.$router.push('managebusines/create')
      // this.reqBusinessId = this.versionDate
      this.$router.push({
        name: 'manageBusinescreate',
        params: {
          type: 'copyBusiness',
          id: this.reqBusinessId
        }
      })
    }
  }
}
</script>
<style scoped>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0 !important;
}
.v-input {
  font-family: "Sarabun", sans-serif;
  font-weight: normal;
  font-size: 14px;
}
.txt-font {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: "Sarabun", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 5px;
  color: #757575;
}
.txt-font-value {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: "Sarabun", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  color: #333333;
}
.txt-head {
  font-family: "Sarabun", sans-serif;
  font-weight: bold;
}
.base-image-input {
  /* display: block; */
  width: 34vh;
  height: 34vh;
  /* padding: 8%; */
  border-radius: 16px;
  cursor: unset;
  background-size: contain !important;
  background-repeat: no-repeat !important;
  background-position: center center !important;
  background: #F8F9FA;
}
.base-image-qrcode {
  display: block;
  width: 150px;
  height: 150px;
  /* padding: 8%; */
  border-radius: 5px;
  cursor: unset;
  background-size: contain;
  background-position: center center;
}
/* src\assets\logo.png */
/* '@/assets/icons/no_user.png' */
/* src\assets\icons\no_user.png */
.placeholder-image {
  /* background: #F0F0F0; */
  background-image: url("../../../assets/icons/insert_photo.png");
  width: 100%;
  height: 100%;
  /* border-radius: 25px; */
  display: flex;
  justify-content: center;
  align-items: center;
  background-repeat: no-repeat !important;
  background-position: center center !important;
  color: #333;
  /* font-size: 18px; */
  font-family: "Sarabun", sans-serif;
}
/* .no-placeholder-image {
  background-image: url("../../../assets/icons/no-image-icon-6.png");
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  background-repeat: no-repeat !important;
  background-position: center center !important;
  font-family: "Sarabun", sans-serif;
} */
.placeholder:hover {
  /* background: #E0E0E0; */
  background-image: url("../../../assets/icons/no-company-7.png");
}
.file-input {
  display: none;
}
.box-image1 {
  border: 1px solid rgba(0, 0, 0, 0.4);
  outline: none;
  color: rgb(118, 118, 118);
  /* display: flex; */
  align-content: center;
  justify-content: center;
  display: grid;
  height: 70%;
  text-align: center;
}
.box-image2 {
  border: dashed;
  border-width: 1px 1px;
  border-radius: 10px;
}
.button {
  border: none;
  color: white;
  /* padding: 15px 32px; */
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
}
.box-image3 {
  border-width: 1px 1px;
  border-radius: 5px;
  border: 2px solid #e7e7e7;
  height: 40px;
}
label {
  background-color: indigo;
  color: white;
  /* padding: 0.5rem; */
  padding: 0.7rem;
  font-family: sans-serif;
  border-radius: 0.3rem;
  cursor: pointer;
  margin-top: 1rem;
}
/* upfile pdf */
/* div.file-listing {
  width: 800px;
} */
.txt-limit {
  white-space: nowrap;
  width: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  /* border: 1px solid #000000; */
}
input[type="file"] {
  position: absolute;
  top: -500px;
  display: none;
}

/* อัปโหลดไฟล์ */
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.btn_click {
  border: 2px solid gray;
  /* color: gray; */
  background-color: white;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: bold;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

.ra-head-text-bold {
  font-family: "Sarabun", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #171F46;
}
.ra-head-text {
  font-family: "Sarabun", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
}
.ra-span-text {
  font-family: "Sarabun", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #757575;
}
.radio-border {
  height: 45px;
  border: 2px solid #ddd;
  border-radius: 5px;
  padding: 15px;
}
.ra-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 9px 24px;

  position: absolute;
  width: 157px;
  height: 36px;

  /* Color / Primary / Default */

  /* background: #3776e9; */
  border-radius: 4px;
}
.ra-text-in-button {
  font-family: "Sarabun", sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
}
.button-qr {
  /* background: none repeat scroll 0 0 #FF0000; */
  border: medium none;
  color: #ffffff;
  height: 50px;
  left: 90.5%;
  position: fixed;
  top: 90%;
  width: 100px;
}
/* v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
} */
span.txt-head {
  color: black;
  font-size: 14px;
}
.v-expansion-panels {
    border-radius: 4px;
    display: unset !important;
    flex-wrap: wrap;
    justify-content: center;
    list-style-type: none;
    padding: 0;
    width: 100%;
    z-index: 1;
}
</style>
